(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-groups"]) return;
  try {
    
  (function () {
    // Range cards: place each price span on a log scale shared by its group,
    // so a 2 699 $ range sits left and a 28 559 $ one right without crushing the rest.
    function placeBars(root) {
      (root || document).querySelectorAll('.vp-group__ranges').forEach(function (grid) {
        var bars = Array.prototype.slice.call(grid.querySelectorAll('.vp-range__prices'));
        var vals = [];
        bars.forEach(function (b) { vals.push(+b.dataset.pmin, +b.dataset.pmax); });
        vals = vals.filter(function (v) { return v > 0; });
        if (vals.length < 2) return;
        var lo = Math.log(Math.min.apply(null, vals));
        var hi = Math.log(Math.max.apply(null, vals));
        if (hi <= lo) return;
        bars.forEach(function (b) {
          var from = (Math.log(+b.dataset.pmin) - lo) / (hi - lo);
          var to = (Math.log(+b.dataset.pmax) - lo) / (hi - lo);
          b.style.setProperty('--vp-from', (from * 100).toFixed(1) + '%');
          b.style.setProperty('--vp-to', ((1 - to) * 100).toFixed(1) + '%');
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { placeBars(); });
    else placeBars();
    document.addEventListener('shopify:section:load', function (e) { placeBars(e.target); });
  })();

  (function () {
    // Range rows: arrows scroll one screen of cards; each hides at its end.
    function setup(rail) {
      if (rail.dataset.vpRailReady) return;
      rail.dataset.vpRailReady = '1';
      var track = rail.querySelector('[data-vp-rail-track]');
      var prev = rail.querySelector('[data-vp-rail-step="-1"]');
      var next = rail.querySelector('[data-vp-rail-step="1"]');
      if (!track || !prev || !next) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max - 2;
      }
      [prev, next].forEach(function (btn) {
        btn.addEventListener('click', function () {
          var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: +btn.dataset.vpRailStep * (track.clientWidth + gap), behavior: calm ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      update();
    }
    function init(root) { (root || document).querySelectorAll('[data-vp-rail]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  (function () {
    // Keep the groups in step with the brand filter when it changes in place
    // (the filter bar swaps the grid and repaints the pills without a reload).
    function brandKey() {
      var q = new URLSearchParams(window.location.search);
      var b = q.get('filter.p.m.custom.brand') || q.get('vp.brand') || '';
      return b.replace(/['’]/g, '').toLowerCase().trim();
    }

    function sync() {
      var root = document.querySelector('.vp-groups');
      if (!root) return;
      var b = brandKey();
      var top = root.querySelector('[data-vp-groups-top]');
      if (top) top.hidden = b !== '';
      var match = null;
      root.querySelectorAll('[data-vp-group-brands]').forEach(function (g) {
        var hit = g.getAttribute('data-vp-group-brands').indexOf('|' + b + '|') !== -1;
        g.hidden = b !== '' && !hit;
        if (b !== '' && hit && g.hasAttribute('data-vp-brand-label')) match = g;
      });
      // The lead-in band: "Tous les celliers EuroCave · 73" once a brand is chosen,
      // "Tous les tire-bouchons · Limonadier · 30" once a type tile is (collection-type-tiles).
      var band = root.querySelector('.vp-groups__allband');
      if (band) {
        var eyebrow = band.querySelector('.vp-groups__all-eyebrow');
        var type = typeLabel();
        var filtered = !!match || type !== '';
        var n = filteredCount();
        if (n === '' && match) n = match.getAttribute('data-vp-brand-count');
        var text = band.getAttribute('data-all-heading') + (match ? ' ' + match.getAttribute('data-vp-brand-label') : '') + (type ? ' · ' + type : '');
        if (n !== '') text += ' · ' + n + ' ' + band.getAttribute(n === '1' ? 'data-model' : 'data-models');
        if (eyebrow) eyebrow.textContent = filtered ? text : eyebrow.getAttribute('data-default');
        band.querySelectorAll('.vp-groups__all-title, .vp-groups__all-text').forEach(function (el) { el.hidden = filtered; });
      }
    }

    // Type chosen through the URL: the tile's own label, else the raw filter values.
    function typeLabel() {
      var nav = document.querySelector('[data-vp-types-param]');
      if (!nav) return '';
      var values = new URLSearchParams(window.location.search).getAll(nav.getAttribute('data-vp-types-param'));
      if (!values.length) return '';
      var tile = Array.prototype.find.call(nav.querySelectorAll('[data-vp-type-values]'), function (a) {
        var own = a.getAttribute('data-vp-type-values');
        return values.every(function (v) { return own.indexOf('|' + v + '|') !== -1; });
      });
      return tile ? tile.getAttribute('data-vp-type-label') : values.join(', ');
    }

    // The filtered grid's own count (« 30 produits »), the number vp-app shows.
    function filteredCount() {
      var el = document.querySelector('[data-vp-count]');
      var m = el && el.textContent.replace(/\s/g, '').match(/\d+/);
      return m ? m[0] : '';
    }

    // "Un choix de 73 celliers EuroCave" (and the last card of the row): same as the
    // EuroCave pill (filter in place, no reload), then down to the grid.
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.vp-groups a[data-vp-brand]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      var brand = link.getAttribute('data-vp-brand');
      var pill = Array.prototype.find.call(document.querySelectorAll('a.brand-axis__pill'), function (a) {
        return new URL(a.href, window.location.origin).searchParams.get('filter.p.m.custom.brand') === brand;
      });
      if (!pill) return;
      e.preventDefault();
      pill.click();
      sync();
      var target = document.getElementById('tous-les-produits');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (target) target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
    });

    function watch() {
      sync();
      var axis = document.querySelector('[data-vp-filter-axis]');
      if (axis && !axis.dataset.vpGroupsWatch) {
        axis.dataset.vpGroupsWatch = '1';
        new MutationObserver(sync).observe(axis, { childList: true });
      }
      // The grid count fills in (or changes) after the page: follow it.
      var count = document.querySelector('[data-vp-count]');
      if (count && !count.dataset.vpGroupsWatch) {
        count.dataset.vpGroupsWatch = '1';
        new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
    window.addEventListener('popstate', sync);
    document.addEventListener('shopify:section:load', watch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-series"]) return;
  try {
    
  (function () {
    // Comparison table: filter chips (zones, door, format) and sortable capacity / price.
    var ZONE_ORDER = ['Simple', 'Single', 'Double', 'Dual', 'Triple', 'Quadruple'];

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var tbody = root.querySelector('tbody');
      var rows = Array.prototype.slice.call(tbody.rows);
      var bar = root.querySelector('.vp-cmp__bar');
      var filters = root.querySelector('.vp-cmp__filters');
      var status = root.querySelector('.vp-cmp__status');
      var empty = root.querySelector('.vp-cmp__empty');
      var facets = [];
      try { facets = JSON.parse(root.dataset.facets || '[]'); } catch (e) { facets = []; }
      var active = {};

      facets.forEach(function (f) {
        var counts = {};
        rows.forEach(function (r) {
          var v = r.dataset[f.key];
          if (v) counts[v] = (counts[v] || 0) + 1;
        });
        var values = Object.keys(counts);
        if (values.length < 2) return;
        values.sort(function (a, b) {
          if (f.key === 'zone') return ZONE_ORDER.indexOf(a) - ZONE_ORDER.indexOf(b);
          return a.localeCompare(b, 'fr');
        });
        active[f.key] = [];
        var group = document.createElement('fieldset');
        group.className = 'vp-cmp__group';
        var legend = document.createElement('legend');
        legend.textContent = f.label;
        group.appendChild(legend);
        var chips = document.createElement('div');
        chips.className = 'vp-cmp__chips';
        [''].concat(values).forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'vp-cmp__chip';
          b.dataset.facet = f.key;
          b.dataset.value = v;
          b.setAttribute('aria-pressed', v === '' ? 'true' : 'false');
          b.textContent = v === '' ? root.dataset.allLabel : v;
          if (v !== '') {
            var n = document.createElement('small');
            n.textContent = counts[v];
            b.appendChild(n);
          }
          chips.appendChild(b);
        });
        group.appendChild(chips);
        filters.appendChild(group);
      });

      function apply() {
        var shown = 0;
        rows.forEach(function (r) {
          var ok = Object.keys(active).every(function (k) {
            return active[k].length === 0 || active[k].indexOf(r.dataset[k]) !== -1;
          });
          r.hidden = !ok;
          if (ok) shown++;
        });
        filters.querySelectorAll('.vp-cmp__chip').forEach(function (b) {
          var list = active[b.dataset.facet];
          b.setAttribute('aria-pressed', String(b.dataset.value === '' ? list.length === 0 : list.indexOf(b.dataset.value) !== -1));
        });
        // Only worth saying once a filter narrows the list.
        status.textContent = shown === rows.length ? '' : (root.dataset.status || '').replace('%shown%', shown).replace('%count%', rows.length);
        empty.hidden = shown > 0;
      }

      filters.addEventListener('click', function (e) {
        var b = e.target.closest('.vp-cmp__chip');
        if (!b) return;
        var list = active[b.dataset.facet];
        var v = b.dataset.value;
        if (v === '') list.length = 0;
        else if (list.indexOf(v) === -1) list.push(v);
        else list.splice(list.indexOf(v), 1);
        apply();
      });

      root.querySelector('.vp-cmp__reset').addEventListener('click', function () {
        Object.keys(active).forEach(function (k) { active[k].length = 0; });
        apply();
      });

      root.querySelectorAll('th[data-sort]').forEach(function (th) {
        th.querySelector('.vp-cmp__sort').addEventListener('click', function () {
          var key = th.dataset.sort;
          var dir = th.getAttribute('aria-sort') === 'ascending' ? 'descending' : 'ascending';
          root.querySelectorAll('th[data-sort]').forEach(function (o) { o.removeAttribute('aria-sort'); });
          th.setAttribute('aria-sort', dir);
          var sign = dir === 'ascending' ? 1 : -1;
          rows.slice().sort(function (a, b) {
            var x = parseFloat(a.dataset[key]);
            var y = parseFloat(b.dataset[key]);
            if (isNaN(x) && isNaN(y)) return 0;
            if (isNaN(x)) return 1;
            if (isNaN(y)) return -1;
            return sign * (x - y);
          }).forEach(function (r) { tbody.appendChild(r); });
        });
      });

      if (Object.keys(active).length > 0) bar.hidden = false;
      apply();
    }

    // Range switcher: bring the current range into view when the row scrolls (phones).
    function centerActivePill() {
      document.querySelectorAll('.vp-series-switch').forEach(function (row) {
        var pill = row.querySelector('.vp-series-switch__pill--active');
        if (!pill || row.scrollWidth <= row.clientWidth) return;
        row.scrollLeft = pill.offsetLeft - (row.clientWidth - pill.offsetWidth) / 2;
      });
    }

    function initAll() { document.querySelectorAll('[data-vp-compare]').forEach(init); centerActivePill(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.collection-page');
    if (!section) return;
    var vpSidebar = section.querySelector('#collection-filters');
    var sectionWrapper = section.closest('[id^="shopify-section-"]');
    var sectionIdAttr = sectionWrapper ? sectionWrapper.id.replace('shopify-section-', '') : null;
    var ANIM_DURATION = 300;

    /* Detect sibling brand-axis section (optional — present on product-type and brand pages) */
    function getBrandAxisInfo() {
      var el = document.querySelector('.brand-axis');
      if (!el) return null;
      var wrapper = el.closest('[id^="shopify-section-"]');
      if (!wrapper) return null;
      return { wrapper: wrapper, id: wrapper.id.replace('shopify-section-', '') };
    }

    /* Detect sibling collection-hero section so we can swap its image/title/tagline on filter change */
    function getHeroInfo() {
      var el = document.querySelector('.collection-hero');
      if (!el) return null;
      var wrapper = el.closest('[id^="shopify-section-"]');
      if (!wrapper) return null;
      return { wrapper: wrapper, id: wrapper.id.replace('shopify-section-', '') };
    }

    /* Record positions of all product cards keyed by product URL */
    function snapshotCards() {
      var map = {};
      section.querySelectorAll('.collection-page__product').forEach(function(card) {
        var link = card.querySelector('.collection-page__product-info');
        var key = link ? link.getAttribute('href') : null;
        if (key) {
          var rect = card.getBoundingClientRect();
          map[key] = { el: card, top: rect.top, left: rect.left, width: rect.width, height: rect.height };
        }
      });
      return map;
    }

    /*
      AJAX filtering with FLIP animations on product cards.
      Fetches section HTML from Shopify (same-origin, section rendering API),
      then animates cards: removed cards scale out, added cards scale in,
      staying cards smoothly move to their new positions.
    */
    /* Client-side prefetch cache — filled on mouseenter, consumed on click */
    var prefetchCache = new Map();

    /* A page previewed with ?view= (a template not yet assigned) keeps it across
       filter changes, or the sections would come from the assigned template. */
    function keepView(url) {
      var view = new URL(window.location.href).searchParams.get('view');
      var next = new URL(url, window.location.origin);
      if (view && !next.searchParams.has('view') && next.pathname === window.location.pathname) next.searchParams.set('view', view);
      return next.toString();
    }

    function buildSectionsUrl(url) {
      url = keepView(url);
      var brandAxisInfo = getBrandAxisInfo();
      var heroInfo = getHeroInfo();
      var sectionIds = [];
      if (sectionIdAttr) sectionIds.push(sectionIdAttr);
      if (brandAxisInfo) sectionIds.push(brandAxisInfo.id);
      if (heroInfo) sectionIds.push(heroInfo.id);
      var fetchUrl = new URL(url, window.location.origin);
      if (sectionIds.length) {
        fetchUrl.searchParams.set('sections', sectionIds.join(','));
      }
      return fetchUrl.toString();
    }

    /* Warm browser image cache for a just-prefetched section response. Extracts
       the hero image URL from the response's data-hero-image-url attribute and
       kicks off an Image() load — so by the time the user clicks, the image is
       already cached and the crossfade starts with no wait. */
    function warmHeroImageFromJson(json) {
      if (!json) return;
      var heroInfo = getHeroInfo();
      if (!heroInfo) return;
      var heroHtml = json[heroInfo.id];
      if (!heroHtml) return;
      var match = heroHtml.match(/data-hero-image-url="([^"]+)"/);
      if (!match) return;
      var imgUrl = match[1].replace(/&amp;/g, '&');
      if (!imgUrl) return;
      var img = new Image();
      img.src = imgUrl;
    }

    function prefetchLink(e) {
      var href = this.href;
      if (!href) return;
      var linkUrl = new URL(href, window.location.origin);
      if (linkUrl.pathname !== window.location.pathname) return;
      if (prefetchCache.has(href)) return;
      var promise = fetch(buildSectionsUrl(href))
        .then(function(res) { return res.json(); })
        .then(function(json) { warmHeroImageFromJson(json); return json; })
        .catch(function() { return null; });
      prefetchCache.set(href, promise);
    }

    /* Eagerly prefetch all filter pill URLs one-by-one during idle time,
       so clicks almost always hit a warm cache. Run on initial load and
       after each AJAX swap (new pills post-filter). */
    function eagerPrefetchAll() {
      var pills = document.querySelectorAll('a.brand-axis__pill, a.brand-axis__sub-pill');
      var queue = [];
      pills.forEach(function(pill) {
        var u = new URL(pill.href, window.location.origin);
        if (u.pathname !== window.location.pathname) return;
        if (prefetchCache.has(pill.href)) return;
        queue.push(pill.href);
      });
      if (!queue.length) return;

      function prefetchNext() {
        if (!queue.length) return;
        var href = queue.shift();
        if (prefetchCache.has(href)) { scheduleNext(); return; }
        var promise = fetch(buildSectionsUrl(href))
          .then(function(r) { return r.json(); })
          .then(function(json) { warmHeroImageFromJson(json); return json; })
          .catch(function() { return null; });
        prefetchCache.set(href, promise);
        /* Chain next prefetch only after this one resolves — serial, not parallel */
        promise.then(scheduleNext, scheduleNext);
      }

      function scheduleNext() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(prefetchNext, { timeout: 2000 });
        } else {
          setTimeout(prefetchNext, 350);
        }
      }

      scheduleNext();
    }

    function fetchAndSwap(url, pushState, chromeOnly) {
      var brandAxisInfo = getBrandAxisInfo();
      var heroInfo = getHeroInfo();

      /* Brand pills on a vp-app collection only refresh the hero and the
         pills. The grid and the Filtres column stay on the vp-app path. */
      if (!chromeOnly) {
        /* FIRST: snapshot current card positions */
        var oldCards = snapshotCards();
        section.style.pointerEvents = 'none';
      }

      /* Use prefetched response if available, else fetch now */
      var promise = prefetchCache.get(url);
      if (!promise) {
        promise = fetch(buildSectionsUrl(url)).then(function(res) { return res.json(); });
      }

      promise
        .then(function(json) {
          var parser = new DOMParser();

          /* Swap main collection section. A brand pill must not do this:
             replacing .collection-page children unmounts the Filtres column. */
          var mainHtml = sectionIdAttr ? json[sectionIdAttr] : null;
          if (mainHtml && !chromeOnly) {
            var doc = parser.parseFromString(mainHtml, 'text/html');
            var newSection = doc.querySelector('.collection-page');

            if (newSection) {
              while (section.firstChild) section.removeChild(section.firstChild);
              while (newSection.firstChild) section.appendChild(newSection.firstChild);

              /* Stagger entrance: first few cards cascade in, the rest drop in
                 together. Keeps perceived motion without dragging out tail. */
              var newCards = section.querySelectorAll('.collection-page__product');
              newCards.forEach(function(card, i) {
                var delay = Math.min(i, 6) * 25;
                card.style.animationDelay = delay + 'ms';
                card.classList.add('is-entering');
              });
              runRequestedScrollTop();
            }

            var newMobile = doc.querySelector('#collection-filters-mobile');
            var oldMobile = document.getElementById('collection-filters-mobile');
            if (newMobile && oldMobile) {
              oldMobile.parentNode.replaceChild(newMobile, oldMobile);
            }
          }

          /* Swap brand-axis section */
          if (brandAxisInfo && json[brandAxisInfo.id]) {
            var axisDoc = parser.parseFromString(json[brandAxisInfo.id], 'text/html');
            var newBrandAxis = axisDoc.querySelector('.brand-axis');
            var oldBrandAxis = document.querySelector('.brand-axis');
            if (newBrandAxis && oldBrandAxis && !oldBrandAxis.hasAttribute('data-vp-filter-axis')) {
              oldBrandAxis.parentNode.replaceChild(newBrandAxis, oldBrandAxis);
            }
          }

          /* Swap collection-hero with a crossfade. Wait for the new image to
             load before starting the fade so the reveal doesn't show a blank
             background while the image is still downloading. If eager prefetch
             has warmed the image cache, this completes synchronously. */
          if (heroInfo && json[heroInfo.id]) {
            var heroDoc = parser.parseFromString(json[heroInfo.id], 'text/html');
            var newHero = heroDoc.querySelector('.collection-hero');
            var oldHero = document.querySelector('.collection-hero');
            if (newHero && oldHero) {
              /* If the new hero's content is identical to the old (e.g. a sidebar
                 bracket filter was clicked — source collection unchanged), skip
                 the crossfade. Running it over identical content just produces a
                 flash of a duplicate. */
              var oldImgUrl = oldHero.getAttribute('data-hero-image-url') || '';
              var newImgUrl = newHero.getAttribute('data-hero-image-url') || '';
              var oldVidUrl = oldHero.getAttribute('data-hero-video-url') || '';
              var newVidUrl = newHero.getAttribute('data-hero-video-url') || '';
              var oldTitleEl = oldHero.querySelector('.collection-hero__title');
              var newTitleEl = newHero.querySelector('.collection-hero__title');
              var oldTitle = oldTitleEl ? oldTitleEl.textContent.trim() : '';
              var newTitle = newTitleEl ? newTitleEl.textContent.trim() : '';
              if (oldImgUrl === newImgUrl && oldVidUrl === newVidUrl && oldTitle === newTitle) {
                /* Nothing changed — leave old hero untouched */
                newHero = null;
              }
            }
            if (newHero && oldHero) {
              newHero.querySelectorAll('[data-animate]').forEach(function(el) {
                el.removeAttribute('data-animate');
              });

              function runCrossfade() {
                oldHero.parentNode.insertBefore(newHero, oldHero);
                newHero.classList.add('is-hero-fading-in');
                oldHero.classList.add('is-hero-fading-out');

                var done = false;
                function cleanup() {
                  if (done) return;
                  done = true;
                  if (oldHero.parentNode) oldHero.remove();
                  newHero.classList.remove('is-hero-fading-in');
                }
                oldHero.addEventListener('animationend', cleanup, { once: true });
                setTimeout(cleanup, 600);
              }

              var heroImgUrl = newHero.getAttribute('data-hero-image-url');
              var heroVidUrl = newHero.getAttribute('data-hero-video-url');
              var started = false;
              function start() {
                if (started) return;
                started = true;
                runCrossfade();
                if (window.__vpPlayCollectionHeroVideos) {
                  window.__vpPlayCollectionHeroVideos(newHero);
                }
              }
              if (heroVidUrl) {
                var vid = newHero.querySelector('.collection-hero__video');
                if (vid) vid.addEventListener('canplay', start, { once: true });
                setTimeout(start, 500);
              } else if (heroImgUrl) {
                var preload = new Image();
                /* Safety timeout: if image is slow, start the crossfade anyway
                   after 500ms so the UI never stalls indefinitely. */
                preload.onload = start;
                preload.onerror = start;
                preload.src = heroImgUrl;
                setTimeout(start, 500);
              } else {
                start();
              }
            }
          }

          /* Mark animated elements as visible (skip scroll entrance animation) */
          section.querySelectorAll('[data-animate]').forEach(function(el) {
            el.classList.add('is-visible');
          });

          /* LAST: snapshot new card positions */
          var newCards = snapshotCards();

          /* All cards appear instantly in their new positions.
             Previously we ran a 300ms FLIP position animation for
             staying cards — that was the main source of perceived
             lag. Truly instant swaps feel much faster. */

          if (!chromeOnly) {
            section.style.pointerEvents = '';

            if (pushState) {
              history.pushState(null, '', keepView(url));
            }

            bindEvents();
            vpSidebar = section.querySelector('#collection-filters');
          } else {
            bindAxisPills();
          }
          /* Re-run eager prefetch for any newly-rendered pills */
          setTimeout(eagerPrefetchAll, 200);
        })
        .catch(function() {
          if (!chromeOnly) window.location.href = url;
        });
    }

    /* Optimistic active-state: flip the clicked pill's active class *before*
       the AJAX response arrives so the user gets instant visual feedback.
       The real render later reconciles if needed. */
    function optimisticallyActivate(link) {
      if (link.classList.contains('brand-axis__pill')) {
        document.querySelectorAll('.brand-axis__pill--active').forEach(function(el) {
          el.classList.remove('brand-axis__pill--active');
        });
        link.classList.add('brand-axis__pill--active');
      } else if (link.classList.contains('brand-axis__sub-pill')) {
        document.querySelectorAll('.brand-axis__sub-pill--active').forEach(function(el) {
          el.classList.remove('brand-axis__sub-pill--active');
        });
        link.classList.add('brand-axis__sub-pill--active');
      }
    }

    /* Brand and sort navigations are built without vp.* params. Keep them
       so a tire-bouchon filter stays applied when the brand axis changes. */
    function preserveVpParams(url) {
      if (!section.querySelector('[data-vp-filter-bar]')) return url;
      var current = new URL(window.location.href);
      var next = new URL(url, window.location.origin);
      var keys = [];
      current.searchParams.forEach(function(_value, key) {
        if (key.indexOf('vp.') === 0 && keys.indexOf(key) === -1) keys.push(key);
      });
      keys.forEach(function(key) {
        next.searchParams.delete(key);
        current.searchParams.getAll(key).forEach(function(value) {
          next.searchParams.append(key, value);
        });
      });
      return next.toString();
    }

    /* Pages swap in place, so a page change would otherwise leave the visitor at the bottom.
       Back to the start of the product list, not the page top: the « Tous les … » heading
       when the page has one, else the grid's own section. It lands under the fixed header,
       counted with its menu row, which reappears while scrolling up. */
    // Full header height (menu row, or the phone's mode bar, unfolded), measured whenever it is open.
    var headerStack = document.querySelector('.vp-header-stack');
    var fullHeaderH = headerStack ? headerStack.offsetHeight : 0;
    function measureHeader() {
      if (headerStack && !document.body.classList.contains('nav-collapsed')) fullHeaderH = headerStack.offsetHeight;
    }
    window.addEventListener('resize', measureHeader);
    function scrollPageTop() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = document.getElementById('tous-les-produits') || section;
      measureHeader();
      // Scrolling up unfolds the header again, so count it at full height.
      var offset = headerStack ? Math.max(headerStack.getBoundingClientRect().bottom, fullHeaderH) : 0;
      var top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }
    window.vpScrollPageTop = scrollPageTop;

    /* A page click only marks the scroll; it runs once the new cards are in, so the visitor
       never reaches the top while the old page is still showing. Stale marks are ignored. */
    var scrollTopRequestedAt = 0;
    function requestScrollTop() {
      scrollTopRequestedAt = Date.now();
    }
    function runRequestedScrollTop() {
      var due = scrollTopRequestedAt && Date.now() - scrollTopRequestedAt < 15000;
      scrollTopRequestedAt = 0;
      if (due) scrollPageTop();
    }

    function interceptLink(e) {
      /* Only intercept links that stay on the current collection page.
         Series pills on brand pages link to different collections — let those navigate normally. */
      var url = new URL(this.href, window.location.origin);
      if (url.pathname !== window.location.pathname) return;
      e.preventDefault();
      var axis = this.classList.contains('brand-axis__pill') || this.classList.contains('brand-axis__sub-pill');
      if (axis && section.querySelector('[data-vp-filter-bar]') && window.vpApplyCollectionUrl) {
        optimisticallyActivate(this);
        var nextUrl;
        if (this.closest('[data-vp-filter-axis]')) {
          var next = new URL(this.href, window.location.origin);
          var current = new URL(window.location.href);
          var drop = (this.getAttribute('data-vp-drop') || '').split(',');
          var vpKeys = [];
          current.searchParams.forEach(function(_value, key) {
            if (key.indexOf('vp.') === 0 && key !== 'vp.page' && vpKeys.indexOf(key) === -1) vpKeys.push(key);
          });
          vpKeys.forEach(function(key) {
            if (drop.indexOf(key) !== -1) {
              next.searchParams.delete(key);
              return;
            }
            if (next.searchParams.has(key)) return;
            current.searchParams.getAll(key).forEach(function(value) {
              next.searchParams.append(key, value);
            });
          });
          next.searchParams.delete('vp.page');
          next.searchParams.delete('page');
          nextUrl = next.toString();
        } else {
          var preserved = new URL(preserveVpParams(this.href), window.location.origin);
          preserved.searchParams.delete('vp.page');
          preserved.searchParams.delete('page');
          nextUrl = preserved.toString();
        }
        window.vpApplyCollectionUrl(nextUrl);
        fetchAndSwap(nextUrl, false, true);
        return;
      }
      optimisticallyActivate(this);
      fetchAndSwap(preserveVpParams(this.href), true);
    }

    function interceptMobileLink(e) {
      var url = new URL(this.href, window.location.origin);
      if (url.pathname !== window.location.pathname) return;
      e.preventDefault();
      closeMobileFilters();
      fetchAndSwap(preserveVpParams(this.href), true);
    }

    function interceptPriceForm(e) {
      e.preventDefault();
      var formData = new FormData(this);
      var url = new URL(window.location.pathname, window.location.origin);
      formData.forEach(function(value, key) {
        if (value) url.searchParams.set(key, value);
      });
      fetchAndSwap(url.toString(), true);
    }

    function interceptMobilePriceForm(e) {
      e.preventDefault();
      var formData = new FormData(this);
      var url = new URL(window.location.pathname, window.location.origin);
      formData.forEach(function(value, key) {
        if (value) url.searchParams.set(key, value);
      });
      closeMobileFilters();
      fetchAndSwap(url.toString(), true);
    }

    /* ── Custom sort dropdown ── */
    function closeSortMenus() {
      document.querySelectorAll('[data-sort-dropdown]').forEach(function(dd) {
        var menu = dd.querySelector('.collection-page__sort-menu');
        var btn = dd.querySelector('.collection-page__sort-button');
        if (menu && !menu.hidden) {
          menu.hidden = true;
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* Document-level close handlers — registered ONCE here (not in
       bindEvents) so AJAX section swaps don't stack duplicates. */
    document.addEventListener('mousedown', function(e) {
      var dd = e.target.closest ? e.target.closest('[data-sort-dropdown]') : null;
      if (!dd) closeSortMenus();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSortMenus();
    });

    function bindSortDropdown() {
      var dropdown = section.querySelector('[data-sort-dropdown]');
      if (!dropdown) return;
      var btn = dropdown.querySelector('.collection-page__sort-button');
      var menu = dropdown.querySelector('.collection-page__sort-menu');
      if (!btn || !menu) return;

      btn.addEventListener('click', function() {
        var isOpen = !menu.hidden;
        closeSortMenus();
        if (!isOpen) {
          menu.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      menu.querySelectorAll('[data-sort-value]').forEach(function(opt) {
        opt.addEventListener('click', function() {
          closeSortMenus();
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', this.getAttribute('data-sort-value'));
          fetchAndSwap(url.toString(), true);
        });
      });
    }

    function bindAxisPills() {
      /* Brand axis pills sit outside the collection section. */
      document.querySelectorAll('a.brand-axis__pill, a.brand-axis__sub-pill').forEach(function(link) {
        if (link.dataset.axisBound === 'true') return;
        link.dataset.axisBound = 'true';
        link.addEventListener('click', interceptLink);
        link.addEventListener('mouseenter', prefetchLink);
        link.addEventListener('mousedown', prefetchLink);
        link.addEventListener('touchstart', prefetchLink, { passive: true });
      });
    }
    window.vpBindAxisPills = bindAxisPills;

    /* The refetched grid needs its own page links, or they keep pointing at the page first loaded. */
    function replaceLiquidPagination(doc) {
      var fresh = doc.querySelector('.collection-page__pagination:not([data-vp-pagination])');
      var navs = section.querySelectorAll('.collection-page__pagination:not([data-vp-pagination])');
      navs.forEach(function(nav, i) { if (i > 0 || !fresh) nav.remove(); });
      if (!fresh) return;
      var clone = document.importNode(fresh, true);
      if (navs[0] && navs[0].isConnected) {
        navs[0].replaceWith(clone);
      } else {
        var grid = section.querySelector('[data-vp-product-grid]');
        if (!grid) return;
        grid.parentNode.insertBefore(clone, grid.nextSibling);
      }
      clone.querySelectorAll('a').forEach(function(link) {
        link.addEventListener('click', interceptLink);
        link.addEventListener('click', requestScrollTop);
      });
    }

    function unfilteredGridUrl() {
      var url = new URL(window.location.href);
      var drop = [];
      url.searchParams.forEach(function(_value, key) {
        if (key.indexOf('vp.') === 0 || key.indexOf('filter.') === 0) drop.push(key);
      });
      drop.forEach(function(key) { url.searchParams.delete(key); });
      return url.toString();
    }

    function stillUnfiltered() {
      var url = new URL(window.location.href);
      var narrowed = false;
      url.searchParams.forEach(function(value, key) {
        if (!value) return;
        if (key.indexOf('filter.') === 0) narrowed = true;
        if (key.indexOf('vp.') === 0 && key !== 'vp.page') narrowed = true;
      });
      return !narrowed;
    }

    document.addEventListener('vp:need-unfiltered-grid', function() {
      if (!window.vpReplaceGridHtml) return;
      fetch(buildSectionsUrl(unfilteredGridUrl()))
        .then(function(res) { return res.json(); })
        .then(function(json) {
          if (!stillUnfiltered()) return;
          var mainHtml = sectionIdAttr ? json[sectionIdAttr] : null;
          if (!mainHtml) return;
          var doc = new DOMParser().parseFromString(mainHtml, 'text/html');
          var grid = doc.querySelector('[data-vp-product-grid]');
          var count = doc.querySelector('[data-vp-count]');
          if (!grid) return;
          window.vpReplaceGridHtml(grid.innerHTML, count ? count.textContent : '');
          replaceLiquidPagination(doc);
        })
        .catch(function() {});
    });

    function bindEvents() {
      /* Custom sort dropdown (re-rendered with the active option on swap) */
      bindSortDropdown();

      /* Filter links (checkboxes), active tags, clear all — sidebar */
      section.querySelectorAll(
        'a.collection-page__filter-value, a.collection-page__active-tag, a.collection-page__clear-all'
      ).forEach(function(link) {
        link.addEventListener('click', interceptLink);
        /* mouseenter: warm prefetch on hover; mousedown: fires ~100ms before click;
           touchstart: mobile users get prefetch since they have no hover state. */
        link.addEventListener('mouseenter', prefetchLink);
        link.addEventListener('mousedown', prefetchLink);
        link.addEventListener('touchstart', prefetchLink, { passive: true });
      });

      bindAxisPills();

      /* Mobile panel filter links */
      var mobilePanel = document.getElementById('collection-filters-mobile');
      if (mobilePanel) {
        mobilePanel.querySelectorAll(
          'a.collection-page__filter-value, a.collection-page__mobile-clear'
        ).forEach(function(link) {
          link.addEventListener('click', interceptMobileLink);
        });
      }

      /* Price range forms — sidebar */
      section.querySelectorAll('.collection-page__price-range form').forEach(function(form) {
        form.addEventListener('submit', interceptPriceForm);
      });
      /* Price range forms — mobile */
      if (mobilePanel) {
        mobilePanel.querySelectorAll('.collection-page__price-range form').forEach(function(form) {
          form.addEventListener('submit', interceptMobilePriceForm);
        });
      }

      /* Pagination links */
      section.querySelectorAll('.collection-page__pagination a').forEach(function(link) {
        link.addEventListener('click', interceptLink);
        link.addEventListener('click', requestScrollTop);
      });

      /* Mobile filter drawer */
      bindMobileFilters();
      if (window.vpInitFilterBar) window.vpInitFilterBar();
    }

    /* Quick add survives a vp-app grid redraw. One listener on the section. */
    section.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || !section.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.style.opacity = '0.6';
      btn.style.pointerEvents = 'none';
      var items = [{ id: parseInt(variantId, 10), quantity: 1 }];
      var feeId = window.vpEcofeeVariantId
        ? window.vpEcofeeVariantId(btn.getAttribute('data-product-type'))
        : null;
      if (feeId) items.push({ id: feeId, quantity: 1 });
      var doorId = window.vpDoorInversionVariantId
        ? window.vpDoorInversionVariantId()
        : null;
      var sku = btn.getAttribute('data-sku') || '';
      var skuIsPg = typeof window.vpSkuEndsPg === 'function'
        ? window.vpSkuEndsPg(sku)
        : /(?:-PG)$/i.test(sku.trim());
      var isCellier = typeof window.vpIsCellierType === 'function'
        ? window.vpIsCellierType(btn.getAttribute('data-product-type'))
        : false;
      if (doorId && skuIsPg && isCellier) items.push({ id: doorId, quantity: 1 });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      })
      .catch(function() {
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      });
    });

    /* ── Mobile filter drawer ── */
    function closeMobileFilters() {
      var mobileFilters = document.getElementById('collection-filters-mobile');
      if (mobileFilters) {
        mobileFilters.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    function bindMobileFilters() {
      var filterToggle = section.querySelector('.collection-page__filter-toggle');
      var mobileFilters = document.getElementById('collection-filters-mobile');
      if (!filterToggle || !mobileFilters) return;

      var overlay = mobileFilters.querySelector('.collection-page__mobile-filters-overlay');
      var closeBtn = mobileFilters.querySelector('.collection-page__mobile-filters-close');
      var applyBtn = mobileFilters.querySelector('.collection-page__mobile-apply');

      filterToggle.addEventListener('click', function() {
        mobileFilters.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
      if (overlay) overlay.addEventListener('click', closeMobileFilters);
      if (closeBtn) closeBtn.addEventListener('click', closeMobileFilters);
      if (applyBtn) applyBtn.addEventListener('click', closeMobileFilters);
    }

    /* Back/forward stays on the vp path while the Filtres column is still
       the same node. A section swap (sort, liquid pagination) replaces it,
       and that history step still reloads the section. */
    window.addEventListener('popstate', function() {
      var sidebar = document.getElementById('collection-filters');
      if (sidebar && sidebar === vpSidebar && section.querySelector('[data-vp-filter-bar]') && window.vpInitFilterBar) {
        window.vpInitFilterBar();
        fetchAndSwap(window.location.href, false, true);
        return;
      }
      fetchAndSwap(window.location.href, false);
    });

    /* Initial bind */
    bindEvents();

    /* Kick off eager prefetch of every pill URL after the critical path is
       clear. Delay ~1s so it doesn't fight the main page for bandwidth. */
    setTimeout(eagerPrefetchAll, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-invoices"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-vp-invoices]');
    if (!root) return;

    var ENDPOINT = '/apps/vp/factures';
    var listEl = root.querySelector('[data-vp-list]');
    var loadingEl = root.querySelector('[data-vp-loading]');
    var emptyEl = root.querySelector('[data-vp-empty]');
    var errorEl = root.querySelector('[data-vp-error]');
    var gateEl = root.querySelector('[data-vp-gate]');
    if (!listEl) return; // non connecté : la porte est déjà visible, rien à charger

    // Étiquettes de ligne : lues en attribut, donc déjà décodées par le parseur
    // HTML. Voir l'entête — ne pas les faire transiter par du Liquid en JS.
    var LOCALE = root.getAttribute('data-locale') || 'fr-CA';
    var L_DOWNLOAD = root.getAttribute('data-label-download');
    var L_CREDIT = root.getAttribute('data-label-credit-note');
    var L_ORDER = root.getAttribute('data-label-order');

    function show(el) { if (el) el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }

    // La porte fait partie des états mutuellement exclusifs : une fois affichée
    // sur un 401, un réessai réussi doit pouvoir la refermer.
    var PANELS = [gateEl, loadingEl, listEl, emptyEl, errorEl];

    function only(el) {
      PANELS.forEach(hide);
      show(el);
    }

    function money(amount, currency) {
      try {
        return new Intl.NumberFormat(LOCALE, {
          style: 'currency',
          currency: currency || 'CAD',
        }).format(amount);
      } catch (e) {
        return amount + ' ' + (currency || '');
      }
    }

    function date(iso) {
      try {
        return new Date(iso).toLocaleDateString(LOCALE, {
          year: 'numeric', month: 'long', day: 'numeric',
        });
      } catch (e) {
        return iso;
      }
    }

    // Les liens expirent en 15 min. Plutôt que d'envoyer la personne vers une
    // erreur de signature si la page est restée ouverte, on re-interroge le
    // proxy au clic pour obtenir un lien frais.
    function download(inv, btn) {
      var stale = !inv.downloadExpiresAt || new Date(inv.downloadExpiresAt) <= new Date();
      if (!stale) {
        window.location.assign(inv.downloadUrl);
        return;
      }
      btn.disabled = true;
      fetch(ENDPOINT, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          var fresh = (data && data.invoices || []).filter(function (i) {
            return i.invoiceNumber === inv.invoiceNumber;
          })[0];
          if (fresh) window.location.assign(fresh.downloadUrl);
          else only(errorEl);
        })
        .catch(function () { only(errorEl); })
        .then(function () { btn.disabled = false; });
    }

    function row(inv) {
      var el = document.createElement('div');
      el.className = 'vp-invoices__row';

      var main = document.createElement('div');
      main.className = 'vp-invoices__main';

      var num = document.createElement('div');
      num.className = 'vp-invoices__num';
      num.textContent = inv.invoiceNumber;
      if (inv.isCreditNote) {
        var badge = document.createElement('span');
        badge.className = 'vp-invoices__badge';
        badge.textContent = L_CREDIT;
        num.appendChild(badge);
      }
      main.appendChild(num);

      var meta = document.createElement('div');
      meta.className = 'vp-invoices__meta';
      var bits = [date(inv.issuedAt)];
      if (inv.orderName) bits.push(L_ORDER + ' ' + inv.orderName);
      meta.textContent = bits.join(' · ');
      main.appendChild(meta);

      var amount = document.createElement('div');
      amount.className = 'vp-invoices__amount';
      amount.textContent = money(inv.total, inv.currency);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vp-invoices__button vp-invoices__dl';
      btn.textContent = L_DOWNLOAD;
      // Un <button> et non un <a href> : l'URL signée ne doit jamais atterrir
      // dans le DOM sous une forme copiable ou partageable par mégarde.
      btn.addEventListener('click', function () { download(inv, btn); });

      el.appendChild(main);
      el.appendChild(amount);
      el.appendChild(btn);
      return el;
    }

    function load() {
      only(loadingEl);
      fetch(ENDPOINT, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (res) {
          if (res.status === 401) return { notLoggedIn: true };
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          if (!data) { only(errorEl); return; }
          if (data.notLoggedIn) {
            // La session a expiré entre le rendu de la page et l'appel.
            only(gateEl);
            return;
          }
          var invoices = data.invoices || [];
          if (!invoices.length) { only(emptyEl); return; }
          listEl.textContent = '';
          invoices.forEach(function (inv) { listEl.appendChild(row(inv)); });
          only(listEl);
        })
        .catch(function () { only(errorEl); });
    }

    var retry = root.querySelector('[data-vp-retry]');
    if (retry) retry.addEventListener('click', load);

    load();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var AUTO_SLIDE_MS = 5000;            // step every N ms
    var PAUSE_AFTER_INTERACT_MS = 9000;  // resume after this many ms idle

    // CSS-transform-based carousel — same pattern as the hero slider.
    // The .featured-products__track flex row is translated horizontally
    // via `transform: translateX(...)`, and the CSS transition on the
    // track does all the animation work. No rAF scroll math, no
    // scroll-snap, just a single style mutation per step. The motion
    // feels naturally smooth because the browser composites transforms
    // on the GPU — same reason the hero's slide feels right.
    //
    // Current position is stored as a card index on the track via
    // data-current-index, so we don't read back layout state mid-animation.

    function visibleGrid(container) {
      var tab = container.querySelector('.featured-products__tab-content:not(.is-hidden)');
      return tab ? tab.querySelector('.featured-products__grid') : null;
    }
    function trackOf(grid) {
      return grid ? grid.querySelector('.featured-products__track') : null;
    }
    function getCardWidth(grid, track) {
      var first = track.firstElementChild;
      if (!first) return 0;
      return first.getBoundingClientRect().width;
    }
    function getGap(track) {
      return parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    }
    function getCurrentIndex(track) {
      return parseInt(track.getAttribute('data-current-index') || '0', 10) || 0;
    }
    function setCurrentIndex(track, idx) {
      track.setAttribute('data-current-index', String(idx));
    }
    function getMaxIndex(grid, track) {
      // How many cards fit in the visible viewport, given current card width.
      var cardW = getCardWidth(grid, track);
      var gap = getGap(track);
      if (cardW <= 0) return 0;
      var visibleCount = Math.max(1, Math.round((grid.clientWidth + gap) / (cardW + gap)));
      return Math.max(0, track.children.length - visibleCount);
    }
    function applyTransform(grid, track, idx) {
      var cardW = getCardWidth(grid, track);
      var gap = getGap(track);
      var x = -(cardW + gap) * idx;
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }
    function updateProgress(container) {
      var grid = visibleGrid(container);
      var track = trackOf(grid);
      var bar = container.querySelector('.featured-products__progress-active');
      if (!grid || !track || !bar) return;
      var max = getMaxIndex(grid, track);
      if (max <= 0) { bar.style.width = '100%'; return; }
      var pct = (getCurrentIndex(track) / max) * 100;
      bar.style.width = Math.max(8, pct) + '%';
    }
    function updateControlsVisibility(container) {
      var controls = container.querySelector('.featured-products__controls');
      if (!controls) return;
      var grid = visibleGrid(container);
      var track = trackOf(grid);
      var hasOverflow = grid && track && getMaxIndex(grid, track) > 0;
      controls.classList.toggle('is-hidden', !hasOverflow);
    }

    // Tab switching
    document.querySelectorAll('.featured-products__tabs[data-tabs-group]').forEach(function (group) {
      var container = group.closest('.featured-products__container');
      if (!container) return;
      var tabs = container.querySelectorAll('.featured-products__tab-content[data-tab-content]');
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-tab-target]');
        if (!btn) return;
        var target = btn.getAttribute('data-tab-target');
        group.querySelectorAll('button[data-tab-target]').forEach(function (b) {
          b.classList.toggle('featured-products__tab--active', b === btn);
        });
        tabs.forEach(function (t) {
          t.classList.toggle('is-hidden', t.getAttribute('data-tab-content') !== target);
        });
        updateProgress(container);
        updateControlsVisibility(container);
      });
    });

    document.querySelectorAll('.featured-products__container').forEach(function (container) {
      var pausedUntil = 0;
      function step(direction) {
        var grid = visibleGrid(container);
        var track = trackOf(grid);
        if (!grid || !track) return;
        var max = getMaxIndex(grid, track);
        if (max <= 0) return;
        var current = getCurrentIndex(track);
        var next;
        if (direction === 1) {
          next = current >= max ? 0 : current + 1;
        } else {
          next = current <= 0 ? max : current - 1;
        }
        setCurrentIndex(track, next);
        applyTransform(grid, track, next);
        updateProgress(container);
      }

      container.querySelectorAll('.featured-products__arrow[data-arrow-direction]').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          step(arrow.getAttribute('data-arrow-direction') === 'next' ? 1 : -1);
          pausedUntil = Date.now() + PAUSE_AFTER_INTERACT_MS;
        });
      });

      container.addEventListener('mouseenter', function () { pausedUntil = Infinity; }, true);
      container.addEventListener('mouseleave', function () { pausedUntil = 0; }, true);

      setInterval(function () {
        if (Date.now() < pausedUntil) return;
        step(1);
      }, AUTO_SLIDE_MS);

      updateProgress(container);
      updateControlsVisibility(container);
    });

    // Re-apply transform on resize: card width is responsive, so the
    // px offset for `currentIndex` changes whenever the viewport reflows.
    // Without this, the visible cards would drift off the boundary.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('.featured-products__container').forEach(function (container) {
          var grid = visibleGrid(container);
          var track = trackOf(grid);
          if (grid && track) {
            var max = getMaxIndex(grid, track);
            var current = Math.min(getCurrentIndex(track), max);
            setCurrentIndex(track, current);
            applyTransform(grid, track, current);
          }
          updateProgress(container);
          updateControlsVisibility(container);
        });
      }, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var menuToggles = document.querySelectorAll('.header__menu-toggle');
  var drawer = document.getElementById('mobile-drawer');
  var drawerClose = document.querySelector('.header__drawer-close');

  function openDrawer() {
    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (drawer) {
    menuToggles.forEach(function(toggle) {
      toggle.addEventListener('click', openDrawer);
    });

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
    });
  }

  var expandButtons = document.querySelectorAll('.header__mobile-expand');
  expandButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      var panel = btn.closest('.header__mobile-item').querySelector('.header__mobile-panel');
      if (panel) {
        if (isExpanded) {
          panel.classList.remove('open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          panel.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  // Measure the fixed header stack's height into --vp-header-stack-h so the
  // body spacer keeps page content starting below it. The ResizeObserver also
  // tracks the nav row's collapse animation frame-by-frame, so content
  // reflows smoothly as the row shrinks/grows.
  //
  // Scroll behavior: the nav row collapses on scroll-down and reappears on
  // scroll-up. On a phone the nav row is hidden, and the same class collapses
  // only the Conservation/Dégustation bar. Banner + main row (logo, search,
  // bag, hamburger) always stay. Held open near the top of the page. Desktop
  // also holds it open while the cursor is over the header.
  (function() {
    var stack = document.querySelector('.vp-header-stack');
    if (!stack) return;

    var setHeight = function() {
      document.documentElement.style.setProperty('--vp-header-stack-h', stack.offsetHeight + 'px');
    };
    setHeight();
    if (window.ResizeObserver) {
      new ResizeObserver(setHeight).observe(stack);
    } else {
      window.addEventListener('resize', setHeight);
    }

    var lastY = window.scrollY;
    var ticking = false;
    var hoverLock = false;
    var collapsed = false;
    var frozen = false;
    var settleTimer = null;
    var phoneQuery = window.matchMedia('(max-width: 768px)');
    var THRESHOLD = 80;  // px from top where the collapsing row always stays open
    var DELTA = 8;       // ignore sub-pixel / jitter scroll noise

    stack.addEventListener('mouseenter', function() { hoverLock = true; });
    stack.addEventListener('mouseleave', function() { hoverLock = false; });

    function setCollapsed(v) {
      if (v === collapsed) return;
      collapsed = v;
      document.body.classList.toggle('nav-collapsed', v);
      // Collapsing/expanding the row changes the page height (the body
      // spacer tracks the header), which rebounds window.scrollY and fires
      // more scroll events — read as a direction change, those bounce the
      // state straight back (the flicker). Freeze state until the 240ms
      // height animation and that rebound have settled, then re-baseline.
      frozen = true;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function() {
        frozen = false;
        lastY = window.scrollY;
      }, 320);
    }

    function update() {
      ticking = false;
      if (frozen) return;

      var y = window.scrollY;

      // Always show near the top, or with the cart open. Desktop hover
      // keeps the menu row open so a mega-menu isn't yanked away. A phone
      // tap leaves :hover stuck, which would pin the mode row, so ignore
      // that lock under 768px.
      var desktopHover = hoverLock && !phoneQuery.matches;
      if (y < THRESHOLD || desktopHover || document.body.classList.contains('cart-drawer-open')) {
        lastY = y;
        setCollapsed(false);
        return;
      }

      var diff = y - lastY;
      if (Math.abs(diff) < DELTA) return;  // jitter — don't even re-baseline
      lastY = y;
      setCollapsed(diff > 0);
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  var hero = document.querySelector('.hero');
  if (hero) {
    function setHeroOffset() {
      var offset = 0;
      var topBanner = document.querySelector('.top-banner');
      var header = document.querySelector('.header');
      if (topBanner) offset += topBanner.getBoundingClientRect().height;
      if (header) offset += header.getBoundingClientRect().height;
      hero.style.setProperty('--hero-offset', offset + 'px');
    }
    setHeroOffset();
    window.addEventListener('resize', setHeroOffset);

    var track = hero.querySelector('[data-track]');
    var allSlides = Array.prototype.slice.call(hero.querySelectorAll('.hero__slide'));
    var allDots = Array.prototype.slice.call(hero.querySelectorAll('.hero__dot'));
    // Slides + dots filtered to the active mode (recomputed on each mode change).
    var visibleSlides = [];
    var visibleDots = [];
    var heroClone = null;
    var currentIndex = 0;
    var inSnap = false;
    var autoplayTimer = null;
    var autoplaySpeed = parseInt(hero.dataset.autoplaySpeed) || 5000;
    var autoplay = hero.dataset.autoplay === 'true';
    // Must match the CSS transition duration on .hero__track.
    var TRANSITION_MS = 1000;

    function getMode() {
      return document.body.classList.contains('mode--degustation') ? 'degustation' : 'conservation';
    }

    function slideMatchesMode(slide, mode) {
      var attr = slide.getAttribute('data-mode-content');
      return !attr || attr === mode;
    }

    // Rebuild the slider for the current body mode. Called on init and on
    // every mode toggle so we cycle only through slides whose mode matches
    // the active body class (mode--conservation / mode--degustation). The
    // previous version cycled through every block regardless of mode, which
    // produced empty positions for hidden slides — that was why a single
    // Degustation slide looked like "3 positions, 2 empty".
    function rebuildForCurrentMode() {
      var mode = getMode();

      if (heroClone && heroClone.parentNode) {
        heroClone.parentNode.removeChild(heroClone);
        heroClone = null;
      }

      visibleSlides = allSlides.filter(function (s) { return slideMatchesMode(s, mode); });
      visibleDots = [];
      allDots.forEach(function (d, i) {
        var ok = slideMatchesMode(allSlides[i], mode);
        d.style.display = ok ? '' : 'none';
        if (ok) visibleDots.push(d);
      });

      // Hide the whole dots container when there's only one (or zero) slide
      // in the active mode — a single dot is useless as navigation.
      var dotsContainer = hero.querySelector('.hero__dots');
      if (dotsContainer) {
        dotsContainer.style.display = visibleSlides.length > 1 ? '' : 'none';
      }

      currentIndex = 0;
      inSnap = false;
      if (track) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(0)';
        // eslint-disable-next-line no-unused-expressions
        track.offsetHeight;
        track.style.transition = '';
      }

      setActive(0);

      // Clone the first visible slide so wrap-around animates forward
      // instead of reverse-sliding. Skip when 0–1 visible slides (nothing
      // to cycle).
      if (track && visibleSlides.length > 1) {
        heroClone = visibleSlides[0].cloneNode(true);
        heroClone.classList.remove('hero__slide--active');
        heroClone.setAttribute('aria-hidden', 'true');
        track.appendChild(heroClone);
      }

      resetAutoplay();
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function syncHeroVideos() {
      var reduce = prefersReducedMotion();
      allSlides.forEach(function (s) {
        var video = s.querySelector('.hero__video');
        if (!video) return;
        if (reduce || !s.classList.contains('hero__slide--active')) {
          video.pause();
          return;
        }
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      });
      if (heroClone) {
        var cloneVideo = heroClone.querySelector('.hero__video');
        if (cloneVideo) cloneVideo.pause();
      }
    }

    function setActive(idx) {
      // Clear active on all real slides, set on the visible-index `idx`.
      allSlides.forEach(function (s) { s.classList.remove('hero__slide--active'); });
      allDots.forEach(function (d) { d.classList.remove('hero__dot--active'); });
      if (visibleSlides[idx]) visibleSlides[idx].classList.add('hero__slide--active');
      if (visibleDots[idx]) visibleDots[idx].classList.add('hero__dot--active');
      syncHeroVideos();
    }

    function slideDurationMs(slide) {
      if (!slide) return autoplaySpeed;
      var custom = parseFloat(slide.getAttribute('data-duration'));
      if (custom > 0) return custom * 1000;
      var videoMs = parseInt(slide.getAttribute('data-video-duration-ms'), 10);
      if (videoMs > 0) return videoMs;
      var video = slide.querySelector('.hero__video');
      if (video && isFinite(video.duration) && video.duration > 0) {
        return Math.round(video.duration * 1000);
      }
      return autoplaySpeed;
    }

    function goToSlide(index) {
      if (inSnap) return;
      currentIndex = index;
      if (track) track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      setActive(currentIndex);
      resetAutoplay();
    }

    function nextSlide() {
      if (inSnap) return;
      if (visibleSlides.length <= 1) return;
      if (currentIndex + 1 < visibleSlides.length) {
        goToSlide(currentIndex + 1);
      } else {
        // Animate forward to the clone (visually slide 0), then snap back.
        currentIndex = visibleSlides.length;
        if (track) track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
        setActive(0);
        resetAutoplay();
        inSnap = true;
        setTimeout(function() {
          if (track) {
            track.style.transition = 'none';
            currentIndex = 0;
            track.style.transform = 'translateX(0)';
            // Force reflow before restoring the transition so the snap
            // doesn't animate.
            // eslint-disable-next-line no-unused-expressions
            track.offsetHeight;
            requestAnimationFrame(function() {
              track.style.transition = '';
              inSnap = false;
            });
          } else {
            inSnap = false;
          }
        }, TRANSITION_MS);
      }
    }

    // Dot clicks: map the clicked dot back to its index in the currently
    // visible set (not its original section.blocks index — those differ
    // whenever some blocks are mode-filtered out of view).
    allDots.forEach(function (dot, originalIdx) {
      dot.addEventListener('click', function () {
        if (inSnap) return;
        var slide = allSlides[originalIdx];
        var idx = visibleSlides.indexOf(slide);
        if (idx < 0) return;
        goToSlide(idx);
      });
    });

    function resetAutoplay() {
      if (autoplayTimer) clearTimeout(autoplayTimer);
      if (!autoplay || visibleSlides.length <= 1) return;
      var idx = currentIndex >= visibleSlides.length ? 0 : currentIndex;
      autoplayTimer = setTimeout(nextSlide, slideDurationMs(visibleSlides[idx]));
    }

    allSlides.forEach(function (slide) {
      var video = slide.querySelector('.hero__video');
      if (!video) return;
      video.addEventListener('loadedmetadata', function () {
        if (!slide.classList.contains('hero__slide--active')) return;
        if (parseFloat(slide.getAttribute('data-duration')) > 0) return;
        resetAutoplay();
      });
    });

    rebuildForCurrentMode();

    // Mode-toggle (snippets/mode-toggle.liquid) flips a body class. Re-init
    // the slider so the visible-slide set + autoplay reflect the new mode.
    var modeObserver = new MutationObserver(function () {
      rebuildForCurrentMode();
    });
    modeObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  // Tab switch: clicking a room tab swaps the visible image-wrapper AND
  // thumbnails set within the same container. Both targets share the same
  // data-room-content="<block.id>" with the tab's data-room-target. Scoped
  // per-container so conservation/degustation modes don't cross-talk.
  (function () {
    document.querySelectorAll('.lookbook__container').forEach(function (container) {
      var tabs = container.querySelectorAll('.lookbook__room-tab[data-room-target]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-room-target');
          tabs.forEach(function (t) {
            t.classList.toggle('lookbook__room-tab--active', t === tab);
          });
          container.querySelectorAll('[data-room-content]').forEach(function (el) {
            el.classList.toggle('is-hidden', el.getAttribute('data-room-content') !== targetId);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-newsletter]');
    if (!root) return;
    var form = root.querySelector('form');
    if (!form || form.querySelector('.newsletter__success')) return;

    var endpoint = root.getAttribute('data-newsletter-endpoint') || '';
    var lang = root.getAttribute('data-newsletter-lang') || 'fr';
    var emailInput = form.querySelector('[data-newsletter-email]');
    var consentInput = form.querySelector('[data-newsletter-consent]');
    var hp = form.querySelector('[data-newsletter-hp]');
    var errEl = form.querySelector('[data-newsletter-error]');
    var btn = form.querySelector('[data-newsletter-submit]');
    var errConsent =
      lang.indexOf('en') === 0
        ? 'Please confirm you want to receive the newsletter.'
        : 'Veuillez confirmer votre inscription à l’infolettre.';
    var errGeneric =
      lang.indexOf('en') === 0
        ? 'Something went wrong. Please try again.'
        : 'Une erreur est survenue. Réessayez.';

    function showError(msg) {
      if (!errEl) return;
      errEl.hidden = false;
      errEl.textContent = msg;
    }

    function clearError() {
      if (!errEl) return;
      errEl.hidden = true;
      errEl.textContent = '';
    }

    form.addEventListener('submit', function (e) {
      clearError();
      if (hp && hp.value) return; // honeypot — let native submit die in spam
      if (consentInput && !consentInput.checked) {
        e.preventDefault();
        showError(errConsent);
        return;
      }
      if (!endpoint || !emailInput || !emailInput.value) return;

      // Fire Omnisend in the background. Do not preventDefault or call
      // form.submit() ourselves — Shopify's customer form needs a real
      // submit so the CAPTCHA token is attached. Skipping that sent
      // people to /contact with "Invalid CAPTCHA token".
      var payload = {
        email: emailInput.value.trim(),
        lang: lang,
        source: 'newsletter',
        consent: true,
        accepts_marketing: true,
        website: hp ? hp.value : '',
      };

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
        mode: 'cors',
        keepalive: true,
      }).catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nos-boutiques"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.nos-boutiques');
    if (!section) return;
    var token = section.getAttribute('data-mapbox-token');
    var style = section.getAttribute('data-mapbox-style') || 'mapbox/streets-v12';
    var maps = section.querySelectorAll('[data-store-map]');
    if (!token || maps.length === 0) return;

    // Lazy-load Mapbox GL JS once for all maps on this page. The library
    // is ~250KB gzipped, so deferring until the page actually paints
    // matters; once loaded, every map on the page shares the same
    // window.mapboxgl reference.
    var libraryLoading = null;
    function loadMapboxLibrary() {
      if (window.mapboxgl) return Promise.resolve(window.mapboxgl);
      if (libraryLoading) return libraryLoading;
      libraryLoading = new Promise(function (resolve, reject) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.5.1/mapbox-gl.css';
        document.head.appendChild(css);
        var script = document.createElement('script');
        script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.5.1/mapbox-gl.js';
        script.onload = function () { resolve(window.mapboxgl); };
        script.onerror = function () { reject(new Error('Failed to load Mapbox GL JS')); };
        document.head.appendChild(script);
      });
      return libraryLoading;
    }

    function buildPopupContent(name, address, phone) {
      // createElement + textContent keeps merchant-pasted markup in
      // address/phone safe — same defensive pattern as the homepage
      // map modal.
      var root = document.createElement('div');
      root.className = 'nos-boutiques__map-popup';
      if (name) {
        var h = document.createElement('h4');
        h.textContent = name;
        root.appendChild(h);
      }
      if (address) {
        var pAddr = document.createElement('p');
        address.split(/\r?\n/).forEach(function (line, i) {
          if (i > 0) pAddr.appendChild(document.createElement('br'));
          pAddr.appendChild(document.createTextNode(line));
        });
        root.appendChild(pAddr);
      }
      if (phone) {
        var pPhone = document.createElement('p');
        pPhone.className = 'nos-boutiques__map-popup-phone';
        pPhone.textContent = phone;
        root.appendChild(pPhone);
      }
      return root;
    }

    loadMapboxLibrary().then(function (mapboxgl) {
      mapboxgl.accessToken = token;
      maps.forEach(function (el) {
        var lat = parseFloat(el.getAttribute('data-map-lat'));
        var lng = parseFloat(el.getAttribute('data-map-lng'));
        var zoom = parseInt(el.getAttribute('data-map-zoom'), 10) || 14;
        var name = el.getAttribute('data-map-name');
        var address = el.getAttribute('data-map-address');
        var phone = el.getAttribute('data-map-phone');
        if (isNaN(lat) || isNaN(lng)) return;

        var map = new mapboxgl.Map({
          container: el,
          style: 'mapbox://styles/' + style,
          center: [lng, lat],
          zoom: zoom,
          attributionControl: true,
        });
        map.addControl(new mapboxgl.NavigationControl(), 'top-right');
        map.on('load', function () {
          var popup = new mapboxgl.Popup({ offset: 28, closeButton: false })
            .setDOMContent(buildPopupContent(name, address, phone));
          var marker = new mapboxgl.Marker({ color: '#f1896e' })
            .setLngLat([lng, lat])
            .setPopup(popup)
            .addTo(map);
          // Open the popup immediately so the store card is visible
          // above the marker without requiring a click.
          marker.togglePopup();
        });
      });
    }).catch(function (err) {
      console.error('Mapbox GL JS failed to load for Nos Boutiques:', err);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare-refonte"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (!document.body.classList.contains('vp-refonte')) return; // only on -refonte templates
    var container = document.querySelector('[data-product-compare]');
    if (!container) return;

    var source = container.getAttribute('data-source');
    if (source !== 'recommendations') return;

    var productId = container.getAttribute('data-product-id');
    var maxProducts = parseInt(container.getAttribute('data-max-products'), 10) || 4;
    if (!productId) return;

    var table = container.querySelector('.product-compare__table');
    var thead = table.querySelector('thead tr');
    var tbody = table.querySelector('tbody');
    var rows = tbody.querySelectorAll('tr');

    function formatMoney(cents) {
      if (typeof window.vpFormatMoney === 'function') return window.vpFormatMoney(cents);
      return (cents / 100).toLocaleString(
        (document.documentElement.lang || 'fr').indexOf('en') === 0 ? 'en-CA' : 'fr-CA',
        {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD',
          currencyDisplay: 'narrowSymbol',
        }
      );
    }

    function truncateWords(text, count) {
      var words = text.split(/\s+/);
      if (words.length <= count) return text;
      return words.slice(0, count).join(' ') + '...';
    }

    function stripHtml(html) {
      var tmp = document.createElement('div');
      tmp.textContent = html;
      return tmp.textContent || '';
    }

    function buildHeaderCell(p) {
      var th = document.createElement('th');
      th.className = 'product-compare__product-cell';

      var header = document.createElement('div');
      header.className = 'product-compare__product-header';

      var imgWrap = document.createElement('a');
      imgWrap.href = p.url;
      imgWrap.className = 'product-compare__product-image';
      imgWrap.setAttribute('aria-label', p.title);
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image + '&width=200';
        img.alt = p.title;
        img.className = 'product-compare__img';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      header.appendChild(imgWrap);

      var name = document.createElement('a');
      name.href = p.url;
      name.className = 'product-compare__product-name';
      name.textContent = p.title;
      header.appendChild(name);

      th.appendChild(header);
      return th;
    }

    function buildTextCell(text) {
      var td = document.createElement('td');
      td.className = 'product-compare__value-cell';
      td.textContent = text;
      return td;
    }

    function buildPriceCell(p) {
      var td = document.createElement('td');
      td.className = 'product-compare__value-cell';
      if (p.compare_at_price && p.compare_at_price > p.price) {
        var sale = document.createElement('span');
        sale.className = 'product-compare__price--sale';
        sale.textContent = formatMoney(p.price);
        var compare = document.createElement('span');
        compare.className = 'product-compare__price--compare';
        compare.textContent = formatMoney(p.compare_at_price);
        td.appendChild(sale);
        td.appendChild(compare);
      } else {
        td.textContent = formatMoney(p.price);
      }
      return td;
    }

    var isCellar = container.hasAttribute('data-is-cellar');

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + maxProducts)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products;
        if (!products || products.length === 0) {
          container.style.display = 'none';
          return;
        }

        products.forEach(function(p) {
          thead.appendChild(buildHeaderCell(p));

          var desc = p.body_html ? truncateWords(stripHtml(p.body_html), 20) : '';
          rows[0].appendChild(buildTextCell(desc));
          rows[1].appendChild(buildPriceCell(p));

          if (isCellar) {
            rows[2].appendChild(buildTextCell('–'));
            rows[3].appendChild(buildTextCell('–'));
            rows[4].appendChild(buildTextCell('–'));
          }
        });
      })
      .catch(function() {
        container.style.display = 'none';
      });
  })();

  // Refonte pages: mute the rows where every model has the same value, so the
  // differences stand out. Columns may arrive later (recommendations source).
  (function () {
    if (!document.body.classList.contains('vp-refonte')) return; // only on -refonte templates
    function markSame() {
      document.querySelectorAll('[data-product-compare] tbody tr').forEach(function (row) {
        var cells = row.querySelectorAll('.product-compare__value-cell');
        if (cells.length < 2) return;
        var first = cells[0].textContent.replace(/\s+/g, ' ').trim();
        var same = Array.prototype.every.call(cells, function (c) { return c.textContent.replace(/\s+/g, ' ').trim() === first; });
        row.classList.toggle('is-same', same);
      });
    }
    window.addEventListener('load', markSame);
    document.addEventListener('DOMContentLoaded', markSame);
    setTimeout(markSame, 2500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (document.body.classList.contains('vp-refonte')) return; // redesigned pages run the -refonte copy
    var container = document.querySelector('[data-product-compare]');
    if (!container) return;

    var source = container.getAttribute('data-source');
    if (source !== 'recommendations') return;

    var productId = container.getAttribute('data-product-id');
    var maxProducts = parseInt(container.getAttribute('data-max-products'), 10) || 4;
    if (!productId) return;

    var table = container.querySelector('.product-compare__table');
    var thead = table.querySelector('thead tr');
    var tbody = table.querySelector('tbody');
    var rows = tbody.querySelectorAll('tr');

    function formatMoney(cents) {
      if (typeof window.vpFormatMoney === 'function') return window.vpFormatMoney(cents);
      return (cents / 100).toLocaleString(
        (document.documentElement.lang || 'fr').indexOf('en') === 0 ? 'en-CA' : 'fr-CA',
        {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD',
          currencyDisplay: 'narrowSymbol',
        }
      );
    }

    function truncateWords(text, count) {
      var words = text.split(/\s+/);
      if (words.length <= count) return text;
      return words.slice(0, count).join(' ') + '...';
    }

    function stripHtml(html) {
      var tmp = document.createElement('div');
      tmp.textContent = html;
      return tmp.textContent || '';
    }

    function buildHeaderCell(p) {
      var th = document.createElement('th');
      th.className = 'product-compare__product-cell';

      var header = document.createElement('div');
      header.className = 'product-compare__product-header';

      var imgWrap = document.createElement('a');
      imgWrap.href = p.url;
      imgWrap.className = 'product-compare__product-image';
      imgWrap.setAttribute('aria-label', p.title);
      if (p.featured_image) {
        var img = document.createElement('img');
        img.src = p.featured_image + '&width=200';
        img.alt = p.title;
        img.className = 'product-compare__img';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      header.appendChild(imgWrap);

      var name = document.createElement('a');
      name.href = p.url;
      name.className = 'product-compare__product-name';
      name.textContent = p.title;
      header.appendChild(name);

      th.appendChild(header);
      return th;
    }

    function buildTextCell(text) {
      var td = document.createElement('td');
      td.className = 'product-compare__value-cell';
      td.textContent = text;
      return td;
    }

    function buildPriceCell(p) {
      var td = document.createElement('td');
      td.className = 'product-compare__value-cell';
      if (p.compare_at_price && p.compare_at_price > p.price) {
        var sale = document.createElement('span');
        sale.className = 'product-compare__price--sale';
        sale.textContent = formatMoney(p.price);
        var compare = document.createElement('span');
        compare.className = 'product-compare__price--compare';
        compare.textContent = formatMoney(p.compare_at_price);
        td.appendChild(sale);
        td.appendChild(compare);
      } else {
        td.textContent = formatMoney(p.price);
      }
      return td;
    }

    var isCellar = container.hasAttribute('data-is-cellar');

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + maxProducts)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.products;
        if (!products || products.length === 0) {
          container.style.display = 'none';
          return;
        }

        products.forEach(function(p) {
          thead.appendChild(buildHeaderCell(p));

          var desc = p.body_html ? truncateWords(stripHtml(p.body_html), 20) : '';
          rows[0].appendChild(buildTextCell(desc));
          rows[1].appendChild(buildPriceCell(p));

          if (isCellar) {
            rows[2].appendChild(buildTextCell('–'));
            rows[3].appendChild(buildTextCell('–'));
            rows[4].appendChild(buildTextCell('–'));
          }
        });
      })
      .catch(function() {
        container.style.display = 'none';
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-refonte"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (!document.body.classList.contains('vp-refonte')) return; // only on -refonte templates
    // Copy link
    document.querySelectorAll('.product-details__share-copy').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var url = btn.getAttribute('data-url');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url);
        }
      });
    });

    // Accordion behavior: force first <details> open on page load and enforce
    // single-open invariant — opening a panel closes any other open siblings.
    // Works across all accordion-style blocks (accordion-panel, spec-table,
    // dimension-table, bundle-composition) since they share the same
    // .accordion-panel container.
    var accordion = document.querySelector('.product-details__accordion');
    if (accordion) {
      var allDetails = accordion.querySelectorAll(':scope > details, :scope > .shopify-block > details');
      if (allDetails.length > 0) {
        var expandAll = accordion.hasAttribute('data-expand-all');
        // Open first, close the rest — ignores merchant-set open_by_default
        // since the user wants the first panel open uniformly across templates.
        // Expanded layout (refonte templates): every panel stays open.
        allDetails.forEach(function(d, i) {
          if (expandAll || i === 0) d.setAttribute('open', '');
          else d.removeAttribute('open');
        });
        // A link to #documents (buy box) opens the documents panel: it is
        // closed by default, which is why customers could not find the PDFs.
        var docs = document.getElementById('documents');
        function openDocs() {
          if (!docs) return;
          docs.setAttribute('open', '');
          // Refonte templates: the PDFs are a tab of the bar under the buy box.
          if (window.vpProductTabs) return window.vpProductTabs.show('documents');
          docs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (location.hash === '#documents') openDocs();
        document.querySelectorAll('a[href="#documents"]').forEach(function(a) {
          a.addEventListener('click', function(e) { e.preventDefault(); openDocs(); history.replaceState(null, '', '#documents'); });
        });
        if (expandAll) allDetails.forEach(function(d) {
          var summary = d.querySelector(':scope > summary');
          if (summary) summary.addEventListener('click', function(e) { e.preventDefault(); });
        });
        // Single-open: when one opens, close the others (not in the expanded layout).
        if (!expandAll) allDetails.forEach(function(d) {
          d.addEventListener('toggle', function() {
            if (!d.open) return;
            allDetails.forEach(function(other) {
              if (other !== d && other.open) other.removeAttribute('open');
            });
          });
        });
      }
    }

    // Desktop: the accessories go under the PDFs in the photo column (three across),
    // so the buy box can run longer and show more of the description. Back in the
    // row on smaller screens. Products without PDFs keep the row.
    var accSidebar = document.querySelector('.product-details--accessories-row .product-details__sidebar');
    var heroDocs = document.querySelector('.product-hero__docs');
    if (accSidebar && heroDocs) {
      var accHome = document.createComment('accessories');
      accSidebar.before(accHome);
      var accDesk = window.matchMedia('(min-width: 990px)');
      var placeAccessories = function() {
        var inHero = accSidebar.parentElement === heroDocs;
        if (accDesk.matches && !inHero) {
          heroDocs.appendChild(accSidebar);
          accSidebar.classList.add('is-in-hero');
        } else if (!accDesk.matches && inHero) {
          accHome.after(accSidebar);
          accSidebar.classList.remove('is-in-hero');
        } else {
          return;
        }
        // The hero fits its description to the column height on resize.
        window.dispatchEvent(new Event('resize'));
      };
      placeAccessories();
      accDesk.addEventListener('change', placeAccessories);
    }

    // Accessories row layout: series then brand (left) and the warranty (right)
    // move above the spec tables.
    var about = document.querySelector('[data-pd-about]');
    if (about) {
      var moveTo = function(id, box) {
        var anchor = document.getElementById(id);
        var panel = anchor && anchor.closest('.product-tabs__panel');
        if (panel && box) box.appendChild(panel);
      };
      var brandsBox = about.querySelector('[data-pd-brands]');
      moveTo('collection', brandsBox);
      moveTo('marque', brandsBox);
      // The warranty becomes one more table with the specs (label, then years).
      var wAnchor = document.getElementById('garantie');
      var wPanel = wAnchor && wAnchor.closest('.product-tabs__panel');
      var specAcc = document.querySelector('.product-details--accessories-row .product-details__accordion');
      if (wPanel && specAcc && wPanel.querySelector('.warranty__card')) {
        var wTitle = wPanel.querySelector('.product-tabs__hero-title');
        var wDetails = document.createElement('details');
        wDetails.className = 'accordion-panel product-details__warranty-panel';
        wDetails.innerHTML = '<summary class="accordion-panel__header"><span class="accordion-panel__title"></span><span class="accordion-panel__indicator" aria-hidden="true"></span></summary><div class="accordion-panel__content"><table class="spec-table" data-no-count><tbody></tbody></table></div>';
        wDetails.querySelector('.accordion-panel__title').textContent = wTitle ? wTitle.textContent.trim() : '';
        var wBody = wDetails.querySelector('tbody');
        wPanel.querySelectorAll('.warranty__card').forEach(function(card) {
          var tr = document.createElement('tr');
          var label = document.createElement('td');
          var value = document.createElement('td');
          label.textContent = (card.querySelector('.warranty__card-label') || {}).textContent || '';
          value.textContent = [(card.querySelector('.warranty__card-years') || {}).textContent, (card.querySelector('.warranty__card-unit') || {}).textContent]
            .map(function(s) { return (s || '').trim(); }).join(' ').toLowerCase();
          tr.appendChild(label);
          tr.appendChild(value);
          wBody.appendChild(tr);
        });
        // Quebec legal warranty note, when the product has one.
        var legal = wPanel.querySelector('.product-tabs__warranty-legal');
        if (legal) wDetails.querySelector('.accordion-panel__content').appendChild(legal);
        // Its chip gives the longest coverage (« Jusqu'à 10 ans »).
        var maxYears = Math.max.apply(null, Array.prototype.map.call(wPanel.querySelectorAll('.warranty__card-years'), function(y) { return parseInt(y.textContent, 10) || 0; }));
        if (maxYears > 0) {
          var wChip = document.createElement('span');
          wChip.className = 'product-details__spec-count';
          wChip.textContent = about.dataset.warrantyUpTo.replace('%count%', maxYears);
          var wSummary = wDetails.querySelector('summary');
          wSummary.insertBefore(wChip, wSummary.querySelector('.accordion-panel__indicator'));
        }
        specAcc.appendChild(wDetails);
        wPanel.remove();
        // One table open at a time, this one included.
        specAcc.addEventListener('toggle', function(e) {
          if (!e.target.open || e.target.tagName !== 'DETAILS') return;
          specAcc.querySelectorAll('details[open]').forEach(function(other) { if (other !== e.target) other.removeAttribute('open'); });
        }, true);
      } else {
        // No warranty (glassware): the care guide takes the warranty's place, as one more table.
        var cAnchor = document.getElementById('entretien');
        var cPanel = cAnchor && cAnchor.closest('.product-tabs__panel');
        var cRow = cPanel && cPanel.querySelector('.product-tabs__care-row');
        if (cRow && specAcc) {
          var cTitle = cPanel.querySelector('.product-tabs__hero-title');
          var cDetails = document.createElement('details');
          cDetails.className = 'accordion-panel product-details__care-panel';
          cDetails.innerHTML = '<summary class="accordion-panel__header"><span class="accordion-panel__title"></span><span class="accordion-panel__indicator" aria-hidden="true"></span></summary><div class="accordion-panel__content"></div>';
          cDetails.querySelector('.accordion-panel__title').textContent = cTitle ? cTitle.textContent.trim() : about.dataset.careTitle;
          // Its chip gives the product's care method (« Lave-Vaisselle »).
          if (cRow.dataset.careChip) {
            var cChip = document.createElement('span');
            cChip.className = 'product-details__spec-count';
            cChip.textContent = cRow.dataset.careChip;
            var cSummary = cDetails.querySelector('summary');
            cSummary.insertBefore(cChip, cSummary.querySelector('.accordion-panel__indicator'));
          }
          cDetails.querySelector('.accordion-panel__content').appendChild(cRow);
          specAcc.appendChild(cDetails);
          cPanel.remove();
        }
      }
      if (about.querySelector('.product-tabs__panel')) about.hidden = false;
      // Each table says how much it holds, so a closed table still tells what is inside:
      // rows for the spec tables, measured values (H, L, P, weight) for the dimensions.
      var addCount = function(el, n, one, other) {
        var details = el.closest('details');
        var header = details && details.querySelector(':scope > summary');
        if (!header || !n || header.querySelector('.product-details__spec-count')) return;
        var chip = document.createElement('span');
        chip.className = 'product-details__spec-count';
        chip.textContent = (n === 1 ? one : other).replace('%count%', n);
        header.insertBefore(chip, header.querySelector('.accordion-panel__indicator'));
      };
      document.querySelectorAll('.product-details__accordion .spec-table:not([data-no-count])').forEach(function(table) {
        addCount(table, table.querySelectorAll('tr').length, about.dataset.countOne, about.dataset.countOther);
      });
      document.querySelectorAll('.product-details__accordion .dimension-table').forEach(function(dims) {
        addCount(dims, dims.querySelectorAll('.dimension-table__cell').length, about.dataset.dimsOne, about.dataset.dimsOther);
      });
      var tabsSection = document.querySelector('.product-tabs');
      if (tabsSection && !tabsSection.querySelector('.product-tabs__panel')) {
        var sec = tabsSection.closest('.shopify-section');
        if (sec) sec.style.display = 'none';
      }
    }

    // Floating page map: a dot per section that exists on the page; the last one whose
    // top has passed the reading line is current. Click scrolls to it.
    var pagenav = document.querySelector('[data-vp-pagenav]');
    if (pagenav) {
      var navList = pagenav.querySelector('.vp-pagenav__list');
      var targets = [
        ['overview', '.product-hero'],
        ['specs', '.product-details__accordion'],
        ['about', '.product-details__about:not([hidden])'],
        ['related', '#similaires'],
        ['compare', '#comparer'],
        ['guides', '.vp-gf']
      ].map(function(t) { return { key: t[0], el: document.querySelector(t[1]) }; })
        .filter(function(t) { return t.el && t.el.offsetParent !== null; });
      var stackEl = document.querySelector('.vp-header-stack, .header-group, header');
      var headerOffset = function() { return stackEl ? Math.max(0, stackEl.getBoundingClientRect().bottom) : 0; };
      targets.forEach(function(t) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vp-pagenav__link';
        btn.innerHTML = '<span class="vp-pagenav__label"></span><span class="vp-pagenav__dot" aria-hidden="true"></span>';
        btn.querySelector('.vp-pagenav__label').textContent = pagenav.getAttribute('data-label-' + t.key);
        btn.addEventListener('click', function() {
          var top = t.el.getBoundingClientRect().top + window.scrollY - headerOffset() - 16;
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: t.key === 'overview' ? 0 : top, behavior: reduce ? 'auto' : 'smooth' });
        });
        li.appendChild(btn);
        navList.appendChild(li);
        t.btn = btn;
      });
      if (targets.length > 1) {
        pagenav.hidden = false;
        var current = null;
        var updateNav = function() {
          // A section is current once its top passes 60% of the screen: it is well in view by then.
          var line = window.innerHeight * 0.6;
          var active = targets[0];
          targets.forEach(function(t) { if (t.el.getBoundingClientRect().top <= line) active = t; });
          // At the very bottom the last section is current even if it is short.
          if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) active = targets[targets.length - 1];
          if (active === current) return;
          current = active;
          targets.forEach(function(t) { t.btn.setAttribute('aria-current', t === active ? 'true' : 'false'); });
        };
        var navTicking = false;
        window.addEventListener('scroll', function() {
          if (navTicking) return;
          navTicking = true;
          requestAnimationFrame(function() { updateNav(); navTicking = false; });
        }, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();
      }
    }

    // Accessory cards: add to cart without leaving the page; the cart drawer opens.
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-match-add]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
      })
        .then(function(r) { if (!r.ok) throw new Error('cart add ' + r.status); return r.json(); })
        .then(function() { document.dispatchEvent(new CustomEvent('cart:updated')); })
        .catch(function() { window.location.href = btn.getAttribute('data-product-url'); })
        .then(function() { btn.disabled = false; });
    });

    // Match grid → 2-row paginated slider: when more than 6 cards render, lay
    // out as a 2×3 grid that scrolls horizontally page-by-page. 4–6 cards fall
    // through to the natural 3-column grid which wraps to 2 rows on its own.
    // Counted at runtime so the same logic covers curated, match-collection,
    // bracket, and other-models render paths uniformly.
    function applySliderMode() {
      document.querySelectorAll('.product-details__match-grid').forEach(function(grid) {
        var wrap = grid.closest('.product-details__match-slider');
        // Refonte layout: always one row, the arrows show only when there is more to see.
        var oneRow = grid.closest('.is-in-hero, .product-details--accessories-row');
        if (oneRow || grid.children.length > 6) {
          grid.classList.add('product-details__match-grid--slider');
          if (wrap) wrap.classList.add('is-slider');
        } else {
          grid.classList.remove('product-details__match-grid--slider');
          if (wrap) wrap.classList.remove('is-slider');
        }
        if (wrap) updateSliderArrows(wrap);
      });
    }

    // Toggle prev/next button visibility + the right-edge fade based on scroll
    // position. Arrows fade out (is-hidden) when there's nothing to scroll
    // toward in their direction. The "is-end-of-scroll" class on the wrap
    // also fades out the right-edge gradient at the end.
    function updateSliderArrows(wrap) {
      var grid = wrap.querySelector('.product-details__match-grid');
      var prev = wrap.querySelector('.product-details__match-arrow--prev');
      var next = wrap.querySelector('.product-details__match-arrow--next');
      if (!grid) return;
      var atStart = grid.scrollLeft <= 1;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
      if (prev) prev.classList.toggle('is-hidden', atStart);
      if (next) next.classList.toggle('is-hidden', atEnd);
      wrap.classList.toggle('is-end-of-scroll', atEnd);
    }

    // Custom smooth-scroll with ease-in-out-cubic over 600ms. Browser-native
    // behavior:'smooth' has unspecified duration/easing — this gives a more
    // deliberate, polished feel. Honors prefers-reduced-motion by jumping to
    // the target instead of animating.
    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function smoothScrollTo(element, target, duration) {
      duration = duration || 600;
      if (prefersReducedMotion) {
        element.scrollLeft = target;
        return;
      }
      var start = element.scrollLeft;
      var distance = target - start;
      if (Math.abs(distance) < 1) return;
      var startTime = performance.now();

      // Temporarily disable scroll-snap during JS animation. With mandatory
      // snap, the browser keeps correcting scrollLeft to the nearest card
      // boundary on every frame, fighting our easing curve and producing
      // stair-step motion. We restore the CSS rule after the animation lands.
      element.style.scrollSnapType = 'none';

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function step(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / duration, 1);
        element.scrollLeft = start + distance * easeInOutCubic(progress);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          // Restore on the next frame so the final scrollLeft commits before
          // snap re-engages — otherwise snap can correct slightly mid-settle.
          requestAnimationFrame(function() {
            element.style.scrollSnapType = '';
          });
        }
      }
      requestAnimationFrame(step);
    }

    // Wire up arrow click handlers — scroll by one full page (visible width)
    // so each click advances by ~3 columns / 6 cards.
    document.querySelectorAll('.product-details__match-slider').forEach(function(wrap) {
      var grid = wrap.querySelector('.product-details__match-grid');
      var prev = wrap.querySelector('.product-details__match-arrow--prev');
      var next = wrap.querySelector('.product-details__match-arrow--next');
      if (!grid) return;
      if (prev) {
        prev.addEventListener('click', function() {
          smoothScrollTo(grid, grid.scrollLeft - grid.clientWidth);
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          smoothScrollTo(grid, grid.scrollLeft + grid.clientWidth);
        });
      }
      grid.addEventListener('scroll', function() { updateSliderArrows(wrap); });
    });

    applySliderMode();
    // The accessories move between the photo column and their own row with the screen width.
    window.addEventListener('resize', function() { clearTimeout(window.vpSliderModeTimer); window.vpSliderModeTimer = setTimeout(applySliderMode, 100); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (document.body.classList.contains('vp-refonte')) return; // redesigned pages run the -refonte copy
    // Copy link
    document.querySelectorAll('.product-details__share-copy').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var url = btn.getAttribute('data-url');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url);
        }
      });
    });

    // Accordion behavior: force first <details> open on page load and enforce
    // single-open invariant — opening a panel closes any other open siblings.
    // Works across all accordion-style blocks (accordion-panel, spec-table,
    // dimension-table, bundle-composition) since they share the same
    // .accordion-panel container.
    var accordion = document.querySelector('.product-details__accordion');
    if (accordion) {
      var allDetails = accordion.querySelectorAll(':scope > details, :scope > .shopify-block > details');
      if (allDetails.length > 0) {
        // Open first, close the rest — ignores merchant-set open_by_default
        // since the user wants the first panel open uniformly across templates.
        allDetails.forEach(function(d, i) {
          if (i === 0) d.setAttribute('open', '');
          else d.removeAttribute('open');
        });
        // Single-open: when one opens, close the others.
        allDetails.forEach(function(d) {
          d.addEventListener('toggle', function() {
            if (!d.open) return;
            allDetails.forEach(function(other) {
              if (other !== d && other.open) other.removeAttribute('open');
            });
          });
        });
      }
    }

    // Match grid → 2-row paginated slider: when more than 6 cards render, lay
    // out as a 2×3 grid that scrolls horizontally page-by-page. 4–6 cards fall
    // through to the natural 3-column grid which wraps to 2 rows on its own.
    // Counted at runtime so the same logic covers curated, match-collection,
    // bracket, and other-models render paths uniformly.
    function applySliderMode() {
      document.querySelectorAll('.product-details__match-grid').forEach(function(grid) {
        var wrap = grid.closest('.product-details__match-slider');
        if (grid.children.length > 6) {
          grid.classList.add('product-details__match-grid--slider');
          if (wrap) wrap.classList.add('is-slider');
        } else {
          grid.classList.remove('product-details__match-grid--slider');
          if (wrap) wrap.classList.remove('is-slider');
        }
        if (wrap) updateSliderArrows(wrap);
      });
    }

    // Toggle prev/next button visibility + the right-edge fade based on scroll
    // position. Arrows fade out (is-hidden) when there's nothing to scroll
    // toward in their direction. The "is-end-of-scroll" class on the wrap
    // also fades out the right-edge gradient at the end.
    function updateSliderArrows(wrap) {
      var grid = wrap.querySelector('.product-details__match-grid');
      var prev = wrap.querySelector('.product-details__match-arrow--prev');
      var next = wrap.querySelector('.product-details__match-arrow--next');
      if (!grid) return;
      var atStart = grid.scrollLeft <= 1;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
      if (prev) prev.classList.toggle('is-hidden', atStart);
      if (next) next.classList.toggle('is-hidden', atEnd);
      wrap.classList.toggle('is-end-of-scroll', atEnd);
    }

    // Custom smooth-scroll with ease-in-out-cubic over 600ms. Browser-native
    // behavior:'smooth' has unspecified duration/easing — this gives a more
    // deliberate, polished feel. Honors prefers-reduced-motion by jumping to
    // the target instead of animating.
    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function smoothScrollTo(element, target, duration) {
      duration = duration || 600;
      if (prefersReducedMotion) {
        element.scrollLeft = target;
        return;
      }
      var start = element.scrollLeft;
      var distance = target - start;
      if (Math.abs(distance) < 1) return;
      var startTime = performance.now();

      // Temporarily disable scroll-snap during JS animation. With mandatory
      // snap, the browser keeps correcting scrollLeft to the nearest card
      // boundary on every frame, fighting our easing curve and producing
      // stair-step motion. We restore the CSS rule after the animation lands.
      element.style.scrollSnapType = 'none';

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function step(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / duration, 1);
        element.scrollLeft = start + distance * easeInOutCubic(progress);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          // Restore on the next frame so the final scrollLeft commits before
          // snap re-engages — otherwise snap can correct slightly mid-settle.
          requestAnimationFrame(function() {
            element.style.scrollSnapType = '';
          });
        }
      }
      requestAnimationFrame(step);
    }

    // Wire up arrow click handlers — scroll by one full page (visible width)
    // so each click advances by ~3 columns / 6 cards.
    document.querySelectorAll('.product-details__match-slider').forEach(function(wrap) {
      var grid = wrap.querySelector('.product-details__match-grid');
      var prev = wrap.querySelector('.product-details__match-arrow--prev');
      var next = wrap.querySelector('.product-details__match-arrow--next');
      if (!grid) return;
      if (prev) {
        prev.addEventListener('click', function() {
          smoothScrollTo(grid, grid.scrollLeft - grid.clientWidth);
        });
      }
      if (next) {
        next.addEventListener('click', function() {
          smoothScrollTo(grid, grid.scrollLeft + grid.clientWidth);
        });
      }
      grid.addEventListener('scroll', function() { updateSliderArrows(wrap); });
    });

    applySliderMode();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero-refonte"]) return;
  try {
    
  (function() {
    if (!document.body.classList.contains('vp-refonte')) return; // only on -refonte templates
    var section = document.querySelector('.product-hero');
    if (!section) return;

    function setOffset() {
      var offset = 0;
      var topBanner = document.querySelector('.top-banner');
      var header = document.querySelector('.header');
      if (topBanner) offset += topBanner.getBoundingClientRect().height;
      if (header) offset += header.getBoundingClientRect().height;
      section.style.setProperty('--product-hero-offset', offset + 'px');
    }
    setOffset();
    window.addEventListener('resize', setOffset);

    // Protection plan toggle
    var warrantyBtn = section.querySelector('.product-hero__warranty-btn');
    if (warrantyBtn) {
      warrantyBtn.addEventListener('click', function() {
        var active = warrantyBtn.getAttribute('data-warranty-active') === 'true';
        var next = !active;
        warrantyBtn.setAttribute('data-warranty-active', String(next));
        warrantyBtn.setAttribute('aria-pressed', String(next));
        warrantyBtn.dispatchEvent(new CustomEvent('warranty:toggle', {
          bubbles: true,
          detail: {
            variantId: warrantyBtn.getAttribute('data-warranty-variant-id'),
            active: next
          }
        }));
      });
    }

    // Description "Voir plus" toggle. Clamped to 8 lines by default (CSS);
    // only shows the toggle button if that clamp actually cut something —
    // scrollHeight > clientHeight means real overflow, so a short
    // description never grows a button with nothing to expand.
    var descWrap = section.querySelector('[data-description-wrap]');
    if (descWrap) {
      var descEl = descWrap.querySelector('[data-description]');
      var descToggle = descWrap.querySelector('[data-description-toggle]');
      if (descEl && descToggle) {
        descWrap.setAttribute('data-clamped', '');
        if (descEl.scrollHeight > descEl.clientHeight + 1) {
          descToggle.hidden = false;
          descToggle.addEventListener('click', function() {
            var expanded = descWrap.hasAttribute('data-expanded');
            if (expanded) {
              descWrap.removeAttribute('data-expanded');
              descToggle.textContent = descToggle.getAttribute('data-label-more');
              descToggle.setAttribute('aria-expanded', 'false');
            } else {
              descWrap.setAttribute('data-expanded', '');
              descToggle.textContent = descToggle.getAttribute('data-label-less');
              descToggle.setAttribute('aria-expanded', 'true');
            }
          });
        } else {
          descWrap.removeAttribute('data-clamped');
        }
        // PDFs under the photo (refonte): show as many description lines as fit so the buy
        // buttons end level with the bottom of the « Accessoires essentiels » row on the left
        // (client, Nov 2026), or with the PDF cards when there are no accessories.
        // Desktop only, recomputed on resize.
        var heroDocs = section.querySelector('.product-hero__docs');
        var heroInfo = section.querySelector('.product-hero__info');
        if (heroDocs && heroInfo) {
          var baseLines = 8;
          var fitDescription = function() {
            descEl.style.webkitLineClamp = '';
            descEl.style.lineClamp = '';
            heroInfo.style.minHeight = '';
            if (window.innerWidth < 990 || descWrap.hasAttribute('data-expanded')) return;
            var lastBottom = function() {
              // The buttons are what should line up with the PDF cards (the form wrapper has spacing below them).
              var btn = heroInfo.querySelector('.product-hero__expert-cta') || heroInfo.querySelector('.product-form__actions');
              if (btn && btn.offsetHeight > 0) return btn.getBoundingClientRect().bottom;
              var kids = Array.prototype.filter.call(heroInfo.children, function(el) { return el.offsetHeight > 0; });
              return kids.length ? kids[kids.length - 1].getBoundingClientRect().bottom : heroInfo.getBoundingClientRect().bottom;
            };
            // Left column bottom: the accessory prices when the accessories sit there (their
            // add-to-cart buttons only show on hover), else the PDF cards.
            var docsBottom = function() {
              var prices = heroDocs.querySelectorAll('.product-details__match-price');
              if (!prices.length) return heroDocs.getBoundingClientRect().bottom;
              return Math.max.apply(null, Array.prototype.map.call(prices, function(el) { return el.getBoundingClientRect().bottom; }));
            };
            var lh = parseFloat(getComputedStyle(descEl).lineHeight) || 24;
            if (descWrap.hasAttribute('data-clamped')) {
              var setLines = function(n) {
                descEl.style.webkitLineClamp = String(n);
                descEl.style.lineClamp = String(n);
                descToggle.hidden = descEl.scrollHeight <= descEl.clientHeight + 1;
                // Whole text shown: no fade at the bottom either.
                descWrap.toggleAttribute('data-fits', descToggle.hidden);
              };
              var lines = Math.max(4, baseLines + Math.floor((docsBottom() - lastBottom()) / lh));
              setLines(lines);
              // The estimate rounds down and the « Voir plus » button comes and goes: add
              // lines one by one while a full line still fits above the target.
              for (var guard = 0; guard < 60 && !descWrap.hasAttribute('data-fits') && docsBottom() - lastBottom() >= lh; guard++) {
                lines += 1;
                setLines(lines);
              }
              // One line too many pushes the buttons past the left column: step back.
              while (lines > 4 && lastBottom() - docsBottom() > 1) {
                lines -= 1;
                setLines(lines);
              }
            }
            // The last few pixels: the bottom block moves down (margin-top: auto) so the
            // buttons end level with the accessory prices (or the PDF cards) on the left.
            var rest = docsBottom() - lastBottom();
            if (rest > 0) heroInfo.style.minHeight = (heroInfo.offsetHeight + rest) + 'px';
          };
          fitDescription();
          window.addEventListener('resize', fitDescription);
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitDescription);
          descToggle.addEventListener('click', function() { setTimeout(fitDescription, 0); });
        }
      }
    }

    // Fulfillment chooser: two selectable option cards (pickup / delivery).
    // The pickup card embeds the store dropdown. Selecting a card persists the
    // mode + announces vp:fulfillment-changed; the store dropdown announces
    // vp:store-changed. The cart drawer turns both into cart attributes.
    // Native checkout stays the source of truth.
    var STORE_KEY = 'vp_selected_store';
    var MODE_KEY = 'vp_fulfillment_mode';
    var fulfillment = section.querySelector('[data-fulfillment]');
    if (fulfillment) {
      var cards = fulfillment.querySelectorAll('[data-fulfillment-tab]');
      var picker = fulfillment.querySelector('[data-pickup-picker]');
      var trigger = picker && picker.querySelector('[data-pickup-trigger]');
      var opts = fulfillment.querySelectorAll('[data-pickup-option]');
      var currentMode = null;

      function setMode(mode, persist) {
        cards.forEach(function(c) {
          var on = c.getAttribute('data-fulfillment-tab') === mode;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-checked', String(on));
        });
        if (persist && mode !== currentMode) {
          localStorage.setItem(MODE_KEY, mode);
          window.dispatchEvent(new CustomEvent('vp:fulfillment-changed', { detail: { mode: mode } }));
        }
        currentMode = mode;
      }

      // ── O-1673: warn when the selected store does not hold the item ──
      // Keep the shopper's store. custom.pickup_stores lists who has it
      // ("Brossard|Laval"); match by substring (display names wrap the
      // location token; settings order is already inverted vs the schema).
      var pickupStoresRaw = fulfillment.getAttribute('data-pickup-stores') || '';
      var storesKnown = pickupStoresRaw !== '';
      var stockedStores = pickupStoresRaw === '__none__'
        ? []
        : pickupStoresRaw.split('|').filter(Boolean);
      var elsewhereEl = fulfillment.querySelector('[data-pickup-elsewhere]');
      var transferDialog = fulfillment.querySelector('[data-pickup-transfer-dialog]');
      var transferBody = transferDialog && transferDialog.querySelector('[data-pickup-transfer-body]');
      var transferOpen = fulfillment.querySelector('[data-pickup-transfer-open]');
      var transferClose = transferDialog && transferDialog.querySelector('[data-pickup-transfer-close]');

      function storeStocks(displayName) {
        // Absent metafield ⇒ not scanned yet ⇒ don't warn.
        // Empty list (__none__) ⇒ stocked nowhere ⇒ transfer.
        if (!storesKnown || !displayName) return true;
        if (!stockedStores.length) return false;
        var hay = displayName.toLowerCase();
        return stockedStores.some(function(loc) { return hay.indexOf(loc.toLowerCase()) !== -1; });
      }

      function updateElsewhere(rawName) {
        if (!elsewhereEl) return;
        var displayed = fulfillment.querySelector('[data-store-name]');
        var name = rawName || (displayed && displayed.textContent.trim()) || '';
        if (storeStocks(name)) {
          elsewhereEl.hidden = true;
          return;
        }
        if (transferBody && transferDialog) {
          transferBody.textContent = (transferDialog.getAttribute('data-msg-transfer') || '').replace('@@', name);
        }
        elsewhereEl.hidden = false;
      }

      if (transferOpen && transferDialog && typeof transferDialog.showModal === 'function') {
        transferOpen.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          updateElsewhere();
          transferDialog.showModal();
        });
      }
      if (transferClose && transferDialog) {
        transferClose.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          transferDialog.close();
        });
      }
      if (transferDialog) {
        transferDialog.addEventListener('click', function(e) {
          if (e.target === transferDialog) transferDialog.close();
        });
      }

      function markStore(name) {
        opts.forEach(function(opt) {
          opt.classList.toggle('active', opt.getAttribute('data-store-value') === name);
        });
        updateElsewhere(name);
      }

      function closePicker() {
        if (!picker) return;
        picker.classList.remove('open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }

      // Pickup blocked for this product: the pickup card renders disabled
      // (no data-fulfillment-tab), so always show delivery selected here —
      // without persisting, so other products keep the shopper's mode.
      var pickupBlocked = fulfillment.hasAttribute('data-pickup-blocked');
      if (pickupBlocked || localStorage.getItem(MODE_KEY) !== 'pickup') {
        setMode('delivery', false);
      } else {
        setMode('pickup', false);
      }
      markStore(localStorage.getItem(STORE_KEY));

      // Select a mode by clicking (or keyboard-activating) its card.
      cards.forEach(function(card) {
        card.addEventListener('click', function() {
          setMode(card.getAttribute('data-fulfillment-tab'), true);
        });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            setMode(card.getAttribute('data-fulfillment-tab'), true);
          }
        });
      });

      // Store dropdown inside the pickup card.
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.stopPropagation(); // don't bubble to the card or document
          setMode('pickup', true); // opening the store implies pickup
          var isOpen = picker.classList.contains('open');
          picker.classList.toggle('open', !isOpen);
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });

        opts.forEach(function(opt) {
          opt.addEventListener('click', function(e) {
            e.stopPropagation();
            var name = opt.getAttribute('data-store-value');
            localStorage.setItem(STORE_KEY, name);
            markStore(name);
            closePicker();
            window.dispatchEvent(new CustomEvent('vp:store-changed', { detail: { store: name } }));
          });
        });

        document.addEventListener('click', closePicker);
      }

      // Keep the store highlight in sync when changed from the top-banner picker.
      window.addEventListener('vp:store-changed', function(e) {
        if (e.detail && e.detail.store) markStore(e.detail.store);
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
  (function() {
    if (document.body.classList.contains('vp-refonte')) return; // redesigned pages run the -refonte copy
    var section = document.querySelector('.product-hero');
    if (!section) return;

    function setOffset() {
      var offset = 0;
      var topBanner = document.querySelector('.top-banner');
      var header = document.querySelector('.header');
      if (topBanner) offset += topBanner.getBoundingClientRect().height;
      if (header) offset += header.getBoundingClientRect().height;
      section.style.setProperty('--product-hero-offset', offset + 'px');
    }
    setOffset();
    window.addEventListener('resize', setOffset);

    // Protection plan toggle
    var warrantyBtn = section.querySelector('.product-hero__warranty-btn');
    if (warrantyBtn) {
      warrantyBtn.addEventListener('click', function() {
        var active = warrantyBtn.getAttribute('data-warranty-active') === 'true';
        var next = !active;
        warrantyBtn.setAttribute('data-warranty-active', String(next));
        warrantyBtn.setAttribute('aria-pressed', String(next));
        warrantyBtn.dispatchEvent(new CustomEvent('warranty:toggle', {
          bubbles: true,
          detail: {
            variantId: warrantyBtn.getAttribute('data-warranty-variant-id'),
            active: next
          }
        }));
      });
    }

    // Description "Voir plus" toggle. Clamped to 8 lines by default (CSS);
    // only shows the toggle button if that clamp actually cut something —
    // scrollHeight > clientHeight means real overflow, so a short
    // description never grows a button with nothing to expand.
    var descWrap = section.querySelector('[data-description-wrap]');
    if (descWrap) {
      var descEl = descWrap.querySelector('[data-description]');
      var descToggle = descWrap.querySelector('[data-description-toggle]');
      if (descEl && descToggle) {
        descWrap.setAttribute('data-clamped', '');
        if (descEl.scrollHeight > descEl.clientHeight + 1) {
          descToggle.hidden = false;
          descToggle.addEventListener('click', function() {
            var expanded = descWrap.hasAttribute('data-expanded');
            if (expanded) {
              descWrap.removeAttribute('data-expanded');
              descToggle.textContent = descToggle.getAttribute('data-label-more');
              descToggle.setAttribute('aria-expanded', 'false');
            } else {
              descWrap.setAttribute('data-expanded', '');
              descToggle.textContent = descToggle.getAttribute('data-label-less');
              descToggle.setAttribute('aria-expanded', 'true');
            }
          });
        } else {
          descWrap.removeAttribute('data-clamped');
        }
      }
    }

    // Fulfillment chooser: two selectable option cards (pickup / delivery).
    // The pickup card embeds the store dropdown. Selecting a card persists the
    // mode + announces vp:fulfillment-changed; the store dropdown announces
    // vp:store-changed. The cart drawer turns both into cart attributes.
    // Native checkout stays the source of truth.
    var STORE_KEY = 'vp_selected_store';
    var MODE_KEY = 'vp_fulfillment_mode';
    var fulfillment = section.querySelector('[data-fulfillment]');
    if (fulfillment) {
      var cards = fulfillment.querySelectorAll('[data-fulfillment-tab]');
      var picker = fulfillment.querySelector('[data-pickup-picker]');
      var trigger = picker && picker.querySelector('[data-pickup-trigger]');
      var opts = fulfillment.querySelectorAll('[data-pickup-option]');
      var currentMode = null;

      function setMode(mode, persist) {
        cards.forEach(function(c) {
          var on = c.getAttribute('data-fulfillment-tab') === mode;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-checked', String(on));
        });
        if (persist && mode !== currentMode) {
          localStorage.setItem(MODE_KEY, mode);
          window.dispatchEvent(new CustomEvent('vp:fulfillment-changed', { detail: { mode: mode } }));
        }
        currentMode = mode;
      }

      // ── O-1673: warn when the selected store does not hold the item ──
      // Keep the shopper's store. custom.pickup_stores lists who has it
      // ("Brossard|Laval"); match by substring (display names wrap the
      // location token; settings order is already inverted vs the schema).
      var pickupStoresRaw = fulfillment.getAttribute('data-pickup-stores') || '';
      var storesKnown = pickupStoresRaw !== '';
      var stockedStores = pickupStoresRaw === '__none__'
        ? []
        : pickupStoresRaw.split('|').filter(Boolean);
      var elsewhereEl = fulfillment.querySelector('[data-pickup-elsewhere]');
      var transferDialog = fulfillment.querySelector('[data-pickup-transfer-dialog]');
      var transferBody = transferDialog && transferDialog.querySelector('[data-pickup-transfer-body]');
      var transferOpen = fulfillment.querySelector('[data-pickup-transfer-open]');
      var transferClose = transferDialog && transferDialog.querySelector('[data-pickup-transfer-close]');

      function storeStocks(displayName) {
        // Absent metafield ⇒ not scanned yet ⇒ don't warn.
        // Empty list (__none__) ⇒ stocked nowhere ⇒ transfer.
        if (!storesKnown || !displayName) return true;
        if (!stockedStores.length) return false;
        var hay = displayName.toLowerCase();
        return stockedStores.some(function(loc) { return hay.indexOf(loc.toLowerCase()) !== -1; });
      }

      function updateElsewhere(rawName) {
        if (!elsewhereEl) return;
        var displayed = fulfillment.querySelector('[data-store-name]');
        var name = rawName || (displayed && displayed.textContent.trim()) || '';
        if (storeStocks(name)) {
          elsewhereEl.hidden = true;
          return;
        }
        if (transferBody && transferDialog) {
          transferBody.textContent = (transferDialog.getAttribute('data-msg-transfer') || '').replace('@@', name);
        }
        elsewhereEl.hidden = false;
      }

      if (transferOpen && transferDialog && typeof transferDialog.showModal === 'function') {
        transferOpen.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          updateElsewhere();
          transferDialog.showModal();
        });
      }
      if (transferClose && transferDialog) {
        transferClose.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          transferDialog.close();
        });
      }
      if (transferDialog) {
        transferDialog.addEventListener('click', function(e) {
          if (e.target === transferDialog) transferDialog.close();
        });
      }

      function markStore(name) {
        opts.forEach(function(opt) {
          opt.classList.toggle('active', opt.getAttribute('data-store-value') === name);
        });
        updateElsewhere(name);
      }

      function closePicker() {
        if (!picker) return;
        picker.classList.remove('open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }

      // Pickup blocked for this product: the pickup card renders disabled
      // (no data-fulfillment-tab), so always show delivery selected here —
      // without persisting, so other products keep the shopper's mode.
      var pickupBlocked = fulfillment.hasAttribute('data-pickup-blocked');
      if (pickupBlocked || localStorage.getItem(MODE_KEY) !== 'pickup') {
        setMode('delivery', false);
      } else {
        setMode('pickup', false);
      }
      markStore(localStorage.getItem(STORE_KEY));

      // Select a mode by clicking (or keyboard-activating) its card.
      cards.forEach(function(card) {
        card.addEventListener('click', function() {
          setMode(card.getAttribute('data-fulfillment-tab'), true);
        });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            setMode(card.getAttribute('data-fulfillment-tab'), true);
          }
        });
      });

      // Store dropdown inside the pickup card.
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.stopPropagation(); // don't bubble to the card or document
          setMode('pickup', true); // opening the store implies pickup
          var isOpen = picker.classList.contains('open');
          picker.classList.toggle('open', !isOpen);
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });

        opts.forEach(function(opt) {
          opt.addEventListener('click', function(e) {
            e.stopPropagation();
            var name = opt.getAttribute('data-store-value');
            localStorage.setItem(STORE_KEY, name);
            markStore(name);
            closePicker();
            window.dispatchEvent(new CustomEvent('vp:store-changed', { detail: { store: name } }));
          });
        });

        document.addEventListener('click', closePicker);
      }

      // Keep the store highlight in sync when changed from the top-banner picker.
      window.addEventListener('vp:store-changed', function(e) {
        if (e.detail && e.detail.store) markStore(e.detail.store);
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-linked-rows"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function cards(products) {
      return (products || []).map(function(product) {
        var image = product.image
          ? '<img src="' + esc(product.image) + '" alt="' + esc(product.title) + '" loading="lazy" width="360">'
          : '';
        var price = product.priceLabel
          ? '<span class="vp-linked-rows__price">' + esc(product.priceLabel) + '</span>'
          : '';
        return '<a class="vp-linked-rows__card" href="' + esc(product.url) + '">' +
          '<span class="vp-linked-rows__image">' + image + '</span>' +
          '<span class="vp-linked-rows__name">' + esc(product.title) + '</span>' +
          price +
        '</a>';
      }).join('');
    }

    function row(title, products) {
      if (!products || !products.length) return '';
      return '<section class="vp-linked-rows__row"><h2 class="vp-linked-rows__title">' + esc(title) + '</h2><div class="vp-linked-rows__track">' + cards(products) + '</div></section>';
    }

    function init(root) {
      if (!root || root.getAttribute('data-vp-rows-loaded') === '1') return;
      root.setAttribute('data-vp-rows-loaded', '1');
      var id = root.getAttribute('data-product-id');
      if (!id) return;
      fetch('/apps/vp/product-rows?product_id=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          var html = row(data.accessoriesTitle, data.accessories) + row(data.similarTitle, data.similar);
          if (!html) return;
          var mount = root.querySelector('[data-vp-linked-rows-mount]');
          if (mount) mount.innerHTML = html;
          root.hidden = false;
        })
        .catch(function() {});
    }

    function boot() {
      document.querySelectorAll('[data-vp-linked-rows]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var container = document.querySelector('[data-product-recommendations]');
    if (!container) return;

    var productId = container.getAttribute('data-product-id');
    var sectionId = container.getAttribute('data-section-id');
    if (!productId || !sectionId) return;

    var url = window.location.pathname + '?section_id=' + sectionId + '&product_id=' + productId;

    fetch(url)
      .then(function(response) { return response.text(); })
      .then(function(text) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-product-recommendations]');
        if (fresh && fresh.childElementCount > 0) {
          container.replaceWith(fresh);
          fresh.classList.add('is-visible');
        }
      })
      .catch(function() {
        /* Silently fail - recommendations are non-critical */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  /* Quick add on these cards: the collection page wires it up, the product page did not
     (the click fell through to the product link). Same items as there: eco fee and door reversal. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.vp-related [data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var items = [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }];
    var type = btn.getAttribute('data-product-type');
    var feeId = window.vpEcofeeVariantId ? window.vpEcofeeVariantId(type) : null;
    if (feeId) items.push({ id: feeId, quantity: 1 });
    var doorId = window.vpDoorInversionVariantId ? window.vpDoorInversionVariantId() : null;
    var sku = btn.getAttribute('data-sku') || '';
    var skuIsPg = typeof window.vpSkuEndsPg === 'function' ? window.vpSkuEndsPg(sku) : /(?:-PG)$/i.test(sku.trim());
    var isCellier = typeof window.vpIsCellierType === 'function' ? window.vpIsCellierType(type) : false;
    if (doorId && skuIsPg && isCellier) items.push({ id: doorId, quantity: 1 });
    btn.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart add ' + r.status); return r.json(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:updated')); })
      .catch(function () { var link = btn.closest('a'); if (link) window.location.href = link.href; })
      .then(function () { btn.disabled = false; });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PROXY = '/apps/vp';
    var PAGE = 10;

    function starBar(rating) {
      var el = document.createElement('span');
      el.className = 'vp-reviews__stars';
      el.style.setProperty('--rating', rating);
      return el;
    }

    function renderReview(r) {
      var item = document.createElement('div');
      item.className = 'vp-reviews__item';

      // Left column: the text.
      var main = document.createElement('div');
      main.className = 'vp-reviews__item-main';

      var top = document.createElement('div');
      top.className = 'vp-reviews__item-top';
      top.appendChild(starBar(r.rating));
      if (r.title) {
        var t = document.createElement('span');
        t.className = 'vp-reviews__item-title';
        t.textContent = r.title;
        top.appendChild(t);
      }
      if (r.verified) {
        var v = document.createElement('span');
        v.className = 'vp-reviews__verified';
        v.textContent = window.vpReviewsStrings.verified;
        top.appendChild(v);
      }
      if (r.lang) {
        var lt = document.createElement('span');
        lt.className = 'vp-reviews__langtag';
        lt.textContent = r.lang.toUpperCase();
        top.appendChild(lt);
      }
      main.appendChild(top);

      var body = document.createElement('p');
      body.className = 'vp-reviews__item-body';
      body.textContent = r.body; // textContent — never trust review HTML
      main.appendChild(body);

      var meta = document.createElement('div');
      meta.className = 'vp-reviews__item-meta';
      var d = new Date((r.createdAt || '').replace(' ', 'T') + 'Z');
      meta.textContent = r.authorName + (isNaN(d) ? '' : ' · ' + d.toLocaleDateString());
      main.appendChild(meta);

      if (r.merchantReply) {
        var reply = document.createElement('div');
        reply.className = 'vp-reviews__reply';
        var lbl = document.createElement('div');
        lbl.className = 'vp-reviews__reply-label';
        lbl.textContent = window.vpReviewsStrings.reply;
        var txt = document.createElement('div');
        txt.textContent = r.merchantReply;
        reply.appendChild(lbl);
        reply.appendChild(txt);
        main.appendChild(reply);
      }

      item.appendChild(main);

      // Right column: the photos (full image, not cropped).
      if (r.media && r.media.length) {
        var gal = document.createElement('div');
        gal.className = 'vp-reviews__media';
        r.media.forEach(function (m) {
          var a = document.createElement('a');
          a.href = m.url;
          a.target = '_blank';
          a.rel = 'noopener';
          var img = document.createElement('img');
          img.className = 'vp-reviews__photo';
          img.src = m.url;
          img.loading = 'lazy';
          img.alt = '';
          a.appendChild(img);
          gal.appendChild(a);
        });
        item.appendChild(gal);
      }

      return item;
    }

    function initSection(root) {
      var productId = root.getAttribute('data-product-id');
      var listEl = root.querySelector('[data-vp-reviews-list]');
      var moreBtn = root.querySelector('[data-vp-reviews-more]');
      var offset = 0;
      var total = 0;
      var filterBar = root.querySelector('[data-vp-filters]');

      // Values of the active (selected) chips in a filter group.
      function activeValues(key) {
        if (!filterBar) return [];
        var g = filterBar.querySelector('[data-vp-filter="' + key + '"]');
        if (!g) return [];
        return Array.prototype.slice.call(g.querySelectorAll('.vp-reviews__chip.is-active'))
          .map(function (c) { return c.getAttribute('data-value'); })
          .filter(function (v) { return v; });
      }

      function load() {
        var url = PROXY + '/list?productId=' + encodeURIComponent(productId) +
          '&limit=' + PAGE + '&offset=' + offset;
        var langs = activeValues('lang');
        var ratings = activeValues('rating');
        if (langs.length) url += '&lang=' + langs.join(',');
        if (ratings.length) url += '&rating=' + ratings.join(',');
        if (activeValues('photos').length) url += '&photos=1';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            if (!data || !data.reviews) return;
            total = data.total || 0;
            data.reviews.forEach(function (r) { listEl.appendChild(renderReview(r)); });
            offset += data.reviews.length;
            if (moreBtn) moreBtn.hidden = offset >= total;
          })
          .catch(function () {});
      }

      // Filter change: clear the list, reset paging, re-query.
      function resetAndLoad() { offset = 0; total = 0; listEl.innerHTML = ''; load(); }

      if (moreBtn) moreBtn.addEventListener('click', load);

      // Multi-select: each chip toggles independently (all selected = show all).
      if (filterBar) {
        Array.prototype.forEach.call(filterBar.querySelectorAll('.vp-reviews__chip'), function (btn) {
          btn.addEventListener('click', function () {
            btn.classList.toggle('is-active');
            resetAndLoad();
          });
        });
      }

      load();

      // Rating picker
      var picker = root.querySelector('[data-vp-rating]');
      if (picker) {
        var hidden = picker.querySelector('input[name="rating"]');
        var btns = Array.prototype.slice.call(picker.querySelectorAll('.vp-reviews__star-btn'));
        btns.forEach(function (b) {
          b.addEventListener('click', function () {
            var val = parseInt(b.getAttribute('data-value'), 10);
            hidden.value = val;
            btns.forEach(function (o, i) {
              o.classList.toggle('is-on', i < val);
              o.setAttribute('aria-checked', i < val ? 'true' : 'false');
            });
          });
        });
      }

      // Carry the review-request token from the email link into the form.
      var form = root.querySelector('[data-vp-reviews-form]');
      if (form) {
        var params = new URLSearchParams(window.location.search);
        var rt = params.get('rt');
        if (rt) {
          var tokenEl = form.querySelector('[data-vp-token]');
          if (tokenEl) tokenEl.value = rt;
          // Buyer arriving from the review-request email may not be logged in;
          // reveal the form and hide the gate note for them.
          var wrap = root.querySelector('[data-vp-form-wrap]');
          var gate = root.querySelector('[data-vp-gate]');
          if (wrap) wrap.hidden = false;
          if (gate) gate.hidden = true;
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var msg = form.querySelector('[data-vp-msg]');
          var S = window.vpReviewsStrings;
          if (!form.querySelector('input[name="rating"]').value) {
            if (msg) { msg.hidden = false; msg.className = 'vp-reviews__msg is-err'; msg.textContent = S.need_rating; }
            return;
          }
          var btn = form.querySelector('.vp-reviews__submit');
          if (btn) btn.disabled = true;
          fetch(PROXY + '/submit', { method: 'POST', body: new FormData(form) })
            .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
            .then(function (r) {
              if (msg) {
                msg.hidden = false;
                if (r.ok && r.body.ok) {
                  msg.className = 'vp-reviews__msg is-ok';
                  msg.textContent = S.thanks;
                  form.reset();
                } else if (r.body && r.body.error === 'not_verified') {
                  msg.className = 'vp-reviews__msg is-err';
                  msg.textContent = S.not_verified;
                } else {
                  msg.className = 'vp-reviews__msg is-err';
                  msg.textContent = S.error;
                }
              }
              if (btn) btn.disabled = false;
            })
            .catch(function () { if (btn) btn.disabled = false; });
        });
      }
    }

    document.querySelectorAll('[data-vp-reviews]').forEach(initSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-refonte"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (!document.body.classList.contains('vp-refonte')) return; // only on -refonte templates
    document.querySelectorAll('[data-product-tabs]').forEach(function(container) {
      var tabs = container.querySelectorAll('[data-tab-index]');
      var panels = container.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var index = this.getAttribute('data-tab-index');

          tabs.forEach(function(t) {
            t.classList.remove('product-tabs__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function(p) {
            p.classList.remove('product-tabs__panel--active');
          });

          this.classList.add('product-tabs__tab--active');
          this.setAttribute('aria-selected', 'true');
          var panel = container.querySelector('[data-tab-panel="' + index + '"]');
          if (panel) panel.classList.add('product-tabs__panel--active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (document.body.classList.contains('vp-refonte')) return; // redesigned pages run the -refonte copy
    document.querySelectorAll('[data-product-tabs]').forEach(function(container) {
      var tabs = container.querySelectorAll('[data-tab-index]');
      var panels = container.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var index = this.getAttribute('data-tab-index');

          tabs.forEach(function(t) {
            t.classList.remove('product-tabs__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function(p) {
            p.classList.remove('product-tabs__panel--active');
          });

          this.classList.add('product-tabs__tab--active');
          this.setAttribute('aria-selected', 'true');
          var panel = container.querySelector('[data-tab-panel="' + index + '"]');
          if (panel) panel.classList.add('product-tabs__panel--active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Modal open/close + Mapbox GL JS lazy-loader. Mapbox GL is ~250KB
    // gzipped, so we only inject the script + CSS when the user actually
    // clicks a map. Subsequent opens reuse the cached library and skip
    // straight to map.init(). The token + style come from the modal's
    // data-* attributes (set server-side in Liquid).
    var modal = document.querySelector('[data-map-modal]');
    if (!modal) return;
    var titleEl = modal.querySelector('[data-modal-title]');
    var mapContainer = modal.querySelector('[data-modal-map]');
    var loadingEl = modal.querySelector('.store-locations__modal-loading');
    var token = modal.getAttribute('data-mapbox-token');
    var style = modal.getAttribute('data-mapbox-style') || 'mapbox/light-v11';
    var currentMap = null;
    var libraryLoading = null;

    function loadMapboxLibrary() {
      if (window.mapboxgl) return Promise.resolve(window.mapboxgl);
      if (libraryLoading) return libraryLoading;
      libraryLoading = new Promise(function (resolve, reject) {
        // CSS first — small file, can land before JS.
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://api.mapbox.com/mapbox-gl-js/v3.5.1/mapbox-gl.css';
        document.head.appendChild(css);
        // Then the JS bundle.
        var script = document.createElement('script');
        script.src = 'https://api.mapbox.com/mapbox-gl-js/v3.5.1/mapbox-gl.js';
        script.onload = function () { resolve(window.mapboxgl); };
        script.onerror = function () { reject(new Error('Failed to load Mapbox GL JS')); };
        document.head.appendChild(script);
      });
      return libraryLoading;
    }

    function buildPopupContent(name, address, phone) {
      // setDOMContent on Mapbox popups accepts a real DOM node, so we
      // build with createElement + textContent rather than innerHTML.
      // That way merchant-pasted markup in address/phone renders as
      // literal text instead of being parsed (defensive against any
      // future block-edit injection vector).
      var root = document.createElement('div');
      root.className = 'store-locations__map-popup';

      if (name) {
        var h = document.createElement('h4');
        h.textContent = name;
        root.appendChild(h);
      }
      if (address) {
        var pAddr = document.createElement('p');
        // Address fields commonly contain a newline between street
        // and city — preserve as <br> while keeping content escaped.
        address.split(/\r?\n/).forEach(function (line, i) {
          if (i > 0) pAddr.appendChild(document.createElement('br'));
          pAddr.appendChild(document.createTextNode(line));
        });
        root.appendChild(pAddr);
      }
      if (phone) {
        var pPhone = document.createElement('p');
        pPhone.className = 'store-locations__map-popup-phone';
        pPhone.textContent = phone;
        root.appendChild(pPhone);
      }
      return root;
    }

    function openModal(lat, lng, name, address, phone) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (titleEl) titleEl.textContent = name || '';
      if (loadingEl) loadingEl.style.display = 'flex';

      loadMapboxLibrary().then(function (mapboxgl) {
        mapboxgl.accessToken = token;
        // Clear any previous map's internal DOM before re-init.
        if (currentMap) { currentMap.remove(); currentMap = null; }
        var styleUrl = 'mapbox://styles/' + style;
        currentMap = new mapboxgl.Map({
          container: mapContainer,
          style: styleUrl,
          center: [parseFloat(lng), parseFloat(lat)],
          zoom: 15,
          // Default attribution control (Mapbox wordmark + © credit)
          // shows in the interactive modal map only — satisfies ToS
          // for the page's primary map view, while the thumbnails on
          // the card stay clean.
          attributionControl: true,
        });
        currentMap.addControl(new mapboxgl.NavigationControl(), 'top-right');
        currentMap.on('load', function () {
          if (loadingEl) loadingEl.style.display = 'none';
          // offset moves the popup tail off the marker tip; closeButton:
          // false hides Mapbox's default X (Mapbox auto-toggles the popup
          // on marker click, which is what the user wants).
          var popup = new mapboxgl.Popup({ offset: 28, closeButton: false })
            .setDOMContent(buildPopupContent(name, address, phone));
          var marker = new mapboxgl.Marker({ color: '#f1896e' })
            .setLngLat([parseFloat(lng), parseFloat(lat)])
            .setPopup(popup)
            .addTo(currentMap);
          // Open the popup immediately so the store card is visible
          // without the user having to discover the marker is clickable.
          // Marker click still toggles it as usual.
          marker.togglePopup();
        });
      }).catch(function (err) {
        if (loadingEl) loadingEl.textContent = 'Erreur de chargement de la carte.';
        console.error(err);
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Keep currentMap around in memory between opens — Mapbox GL's
      // init is the costly step, not the marker move. The map gets
      // re-created on next open because container DOM gets reset.
    }

    document.querySelectorAll('[data-open-map-modal]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        // Intercept the click — fall back to native href (Google Maps)
        // only if JS hasn't loaded or token is missing.
        if (!token) return;
        e.preventDefault();
        openModal(
          link.getAttribute('data-map-lat'),
          link.getAttribute('data-map-lng'),
          link.getAttribute('data-map-name'),
          link.getAttribute('data-map-address'),
          link.getAttribute('data-map-phone')
        );
      });
    });

    modal.querySelectorAll('[data-close-map-modal]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  })();

  // Schedule modal — independent IIFE. The shell (overlay, close
  // button, title node) reuses the same class names as the map modal
  // so the existing CSS rules apply automatically. Only behavior
  // differs: read hours from the clicked button's data-schedule-hours,
  // parse each line as "Day | Time", inject zebra-striped rows.
  (function () {
    var modal = document.querySelector('[data-schedule-modal]');
    if (!modal) return;
    var titleEl = modal.querySelector('[data-schedule-title]');
    var bodyEl = modal.querySelector('[data-schedule-body]');

    function buildRow(day, time) {
      var tr = document.createElement('tr');
      var tdDay = document.createElement('td');
      var tdTime = document.createElement('td');
      tdDay.textContent = day;
      tdTime.textContent = time;
      tr.appendChild(tdDay);
      tr.appendChild(tdTime);
      return tr;
    }

    function openSchedule(name, hours) {
      // Replace tbody contents with fresh rows. textContent on each
      // cell sidesteps any HTML injection risk if a merchant pastes
      // markup into the hours textarea.
      while (bodyEl.firstChild) bodyEl.removeChild(bodyEl.firstChild);
      hours.split(/\r?\n/).forEach(function (line) {
        var trimmed = line.trim();
        if (!trimmed) return;
        // Split on the FIRST `|` only — the time portion can itself
        // contain `|` (rare but possible if merchant writes e.g.
        // "ouvert | fermé"). slice(1).join keeps it intact.
        var parts = trimmed.split('|');
        if (parts.length < 2) return;
        var day = parts[0].trim();
        var time = parts.slice(1).join('|').trim();
        bodyEl.appendChild(buildRow(day, time));
      });
      titleEl.textContent = name || '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeSchedule() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-open-schedule-modal]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSchedule(
          btn.getAttribute('data-schedule-name'),
          btn.getAttribute('data-schedule-hours') || ''
        );
      });
    });

    modal.querySelectorAll('[data-close-schedule-modal]').forEach(function (btn) {
      btn.addEventListener('click', closeSchedule);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeSchedule();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subcategories"] && !Shopify.designMode) return;
  try {
    
  // Subcategories tab switcher. Each tab bar declares its mode via
  // data-tabs-for ("conservation" | "degustation"); each grid declares the
  // same mode via data-mode-content. Click on a tab → look up the
  // sibling grid in the same mode → set its data-active-tab → toggle
  // .is-hidden on cards whose data-tab !== active.
  function vpInitSubcategoriesTabs(root) {
    var scope = root || document;
    var tabBars = scope.querySelectorAll('.subcategories__tabs[data-tabs-for]');
    tabBars.forEach(function (tabBar) {
      var mode = tabBar.getAttribute('data-tabs-for');
      var grid = scope.querySelector('.subcategories__grid[data-mode-content="' + mode + '"]');
      if (!grid) return;

      function applyActive(tabHandle) {
        // Toggle button --active class
        tabBar.querySelectorAll('.subcategories__tab').forEach(function (btn) {
          if (btn.getAttribute('data-tab') === tabHandle) {
            btn.classList.add('subcategories__tab--active');
          } else {
            btn.classList.remove('subcategories__tab--active');
          }
        });
        // Toggle card visibility
        grid.setAttribute('data-active-tab', tabHandle);
        grid.querySelectorAll('.subcategories__card').forEach(function (card) {
          if (card.getAttribute('data-tab') === tabHandle) {
            card.classList.remove('is-hidden');
          } else {
            card.classList.add('is-hidden');
          }
        });
      }

      // Initial render: hide cards that don't match the server-set active tab.
      var initialTab = grid.getAttribute('data-active-tab');
      if (initialTab) applyActive(initialTab);

      // Wire clicks.
      tabBar.querySelectorAll('.subcategories__tab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tabHandle = btn.getAttribute('data-tab');
          if (tabHandle) applyActive(tabHandle);
        });
      });
    });
  }
  vpInitSubcategoriesTabs(document);
  // Re-init when Shopify section editor swaps the section in/out.
  document.addEventListener('shopify:section:load', function (e) {
    vpInitSubcategoriesTabs(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var STORE_KEY = 'vp_selected_store';
    var picker = document.getElementById('store-picker');
    if (!picker) return;

    var btn = picker.querySelector('.top-banner__store-button');
    var options = picker.querySelectorAll('.top-banner__store-option');
    var saved = localStorage.getItem(STORE_KEY);

    function storeMeta(name) {
      var n1 = picker.getAttribute('data-store-1-name') || '';
      var n2 = picker.getAttribute('data-store-2-name') || '';
      if (name === n2) {
        return {
          address: picker.getAttribute('data-store-2-address') || '',
          phone: picker.getAttribute('data-store-2-phone') || ''
        };
      }
      return {
        address: picker.getAttribute('data-store-1-address') || '',
        phone: picker.getAttribute('data-store-1-phone') || ''
      };
    }

    function updateStoreName(name) {
      document.querySelectorAll('[data-store-name]').forEach(function(el) {
        el.textContent = name;
      });
      var meta = storeMeta(name);
      document.querySelectorAll('[data-store-address]').forEach(function(el) {
        el.textContent = meta.address;
        el.hidden = !meta.address;
      });
      document.querySelectorAll('[data-store-phone]').forEach(function(el) {
        el.textContent = meta.phone;
        el.hidden = !meta.phone;
      });
      options.forEach(function(opt) {
        opt.classList.toggle('active', opt.getAttribute('data-store-value') === name);
      });
    }

    function selectStore(name, persist) {
      if (persist) localStorage.setItem(STORE_KEY, name);
      updateStoreName(name);
      window.dispatchEvent(new CustomEvent('vp:store-changed', { detail: { store: name } }));
    }

    // Silent IP-based auto-select for first-time visitors: pick the nearest
    // store by approximate location. No permission prompt; fails silently and
    // leaves the default store on any error. Result is persisted so it only
    // runs once and the manual picker always overrides it.
    function autoSelectNearestStore() {
      var s1 = [parseFloat(picker.getAttribute('data-store-1-lat')), parseFloat(picker.getAttribute('data-store-1-lng'))];
      var s2 = [parseFloat(picker.getAttribute('data-store-2-lat')), parseFloat(picker.getAttribute('data-store-2-lng'))];
      if (options.length < 2 || [s1[0], s1[1], s2[0], s2[1]].some(isNaN)) return;

      function dist(a, b, lat, lng) {
        var dLat = lat - a, dLng = lng - b;
        // Equirectangular approximation — plenty precise for "which of two".
        var x = dLng * Math.cos((a + lat) * Math.PI / 360);
        return x * x + dLat * dLat;
      }

      fetch('https://ipapi.co/json/')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(geo) {
          if (!geo || typeof geo.latitude !== 'number' || typeof geo.longitude !== 'number') return;
          if (localStorage.getItem(STORE_KEY)) return; // user chose during the fetch
          var nearIdx = dist(s1[0], s1[1], geo.latitude, geo.longitude) <= dist(s2[0], s2[1], geo.latitude, geo.longitude) ? 0 : 1;
          selectStore(options[nearIdx].getAttribute('data-store-value'), true);
        })
        .catch(function() {});
    }

    if (saved) {
      updateStoreName(saved);
    } else if (options.length) {
      options[0].classList.add('active');
      autoSelectNearestStore();
    }

    // Reflect store changes coming from other selectors (e.g. the product-page
    // pickup dropdown) here too. updateStoreName doesn't dispatch, so no loop.
    window.addEventListener('vp:store-changed', function(e) {
      if (e.detail && e.detail.store) updateStoreName(e.detail.store);
    });

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = picker.classList.contains('open');
      picker.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });

    options.forEach(function(opt) {
      function choose() {
        selectStore(opt.getAttribute('data-store-value'), true);
        picker.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      }
      opt.addEventListener('click', choose);
      opt.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          choose();
        }
      });
    });

    picker.querySelectorAll('[data-store-phone-link]').forEach(function(a) {
      a.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    });

    var dropdown = picker.querySelector('.top-banner__store-dropdown');
    if (dropdown) {
      dropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }

    document.addEventListener('click', function() {
      picker.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-promotion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var timers = document.querySelectorAll('[data-countdown-end]');
    timers.forEach(function(timer) {
      var endDate = new Date(timer.dataset.countdownEnd).getTime();
      if (isNaN(endDate)) return;

      function update() {
        var now = Date.now();
        var diff = Math.max(0, endDate - now);
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        var daysEl = timer.querySelector('[data-days]');
        var hoursEl = timer.querySelector('[data-hours]');
        var minutesEl = timer.querySelector('[data-minutes]');
        var secondsEl = timer.querySelector('[data-seconds]');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      }

      update();
      setInterval(update, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
